(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["arangojs"] = factory();
	else
		root["arangojs"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 18);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __webpack_require__(22);
var messages = {
    0: "Network Error",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Failed",
    413: "Payload Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    421: "Misdirected Request",
    422: "Unprocessable Entity",
    423: "Locked",
    424: "Failed Dependency",
    426: "Upgrade Required",
    428: "Precondition Required",
    429: "Too Many Requests",
    431: "Request Header Fields Too Large",
    444: "Connection Closed Without Response",
    451: "Unavailable For Legal Reasons",
    499: "Client Closed Request",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported",
    506: "Variant Also Negotiates",
    507: "Insufficient Storage",
    508: "Loop Detected",
    510: "Not Extended",
    511: "Network Authentication Required",
    599: "Network Connect Timeout Error"
};
var nativeErrorKeys = ["fileName", "lineNumber", "columnNumber", "stack", "description", "number"];
function isArangoError(err) {
    return Boolean(err && err.isArangoError);
}
exports.isArangoError = isArangoError;

var ArangoError = function (_error_1$default) {
    _inherits(ArangoError, _error_1$default);

    function ArangoError(response) {
        _classCallCheck(this, ArangoError);

        var _this = _possibleConstructorReturn(this, (ArangoError.__proto__ || Object.getPrototypeOf(ArangoError)).call(this));

        _this.name = "ArangoError";
        _this.isArangoError = true;
        _this.response = response;
        _this.statusCode = response.statusCode;
        _this.message = response.body.errorMessage;
        _this.errorNum = response.body.errorNum;
        _this.code = response.body.code;
        var err = new Error(_this.message);
        err.name = _this.name;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = nativeErrorKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                if (err[key]) _this[key] = err[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return _this;
    }

    return ArangoError;
}(error_1.default);

exports.ArangoError = ArangoError;

var HttpError = function (_error_1$default2) {
    _inherits(HttpError, _error_1$default2);

    function HttpError(response) {
        _classCallCheck(this, HttpError);

        var _this2 = _possibleConstructorReturn(this, (HttpError.__proto__ || Object.getPrototypeOf(HttpError)).call(this));

        _this2.name = "HttpError";
        _this2.response = response;
        _this2.statusCode = response.statusCode || 500;
        _this2.message = messages[_this2.statusCode] || messages[500];
        _this2.code = _this2.statusCode;
        var err = new Error(_this2.message);
        err.name = _this2.name;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = nativeErrorKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                if (err[key]) _this2[key] = err[key];
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return _this2;
    }

    return HttpError;
}(error_1.default);

exports.HttpError = HttpError;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var cursor_1 = __webpack_require__(6);
var error_1 = __webpack_require__(0);
var CollectionType;
(function (CollectionType) {
    CollectionType[CollectionType["DOCUMENT_COLLECTION"] = 2] = "DOCUMENT_COLLECTION";
    CollectionType[CollectionType["EDGE_COLLECTION"] = 3] = "EDGE_COLLECTION";
})(CollectionType = exports.CollectionType || (exports.CollectionType = {}));
function isArangoCollection(collection) {
    return Boolean(collection && collection.isArangoCollection);
}
exports.isArangoCollection = isArangoCollection;
exports.DOCUMENT_NOT_FOUND = 1202;
exports.COLLECTION_NOT_FOUND = 1203;

var BaseCollection = function () {
    function BaseCollection(connection, name) {
        _classCallCheck(this, BaseCollection);

        this.isArangoCollection = true;
        this.name = name;
        this._idPrefix = this.name + "/";
        this._connection = connection;
        if (this._connection.arangoMajor >= 3) {
            this.first = undefined;
            this.last = undefined;
            this.createCapConstraint = undefined;
        }
    }

    _createClass(BaseCollection, [{
        key: "_documentPath",
        value: function _documentPath(documentHandle) {
            return "/document/" + this._documentHandle(documentHandle);
        }
    }, {
        key: "_documentHandle",
        value: function _documentHandle(documentHandle) {
            if (typeof documentHandle !== "string") {
                if (documentHandle._id) {
                    return documentHandle._id;
                }
                if (documentHandle._key) {
                    return this._idPrefix + documentHandle._key;
                }
                throw new Error("Document handle must be a document or string");
            }
            if (documentHandle.indexOf("/") === -1) {
                return this._idPrefix + documentHandle;
            }
            return documentHandle;
        }
    }, {
        key: "_indexHandle",
        value: function _indexHandle(indexHandle) {
            if (typeof indexHandle !== "string") {
                if (indexHandle.id) {
                    return indexHandle.id;
                }
                throw new Error("Index handle must be a index or string");
            }
            if (indexHandle.indexOf("/") === -1) {
                return this._idPrefix + indexHandle;
            }
            return indexHandle;
        }
    }, {
        key: "_get",
        value: function _get(path, qs) {
            return this._connection.request({ path: "/_api/collection/" + this.name + "/" + path, qs: qs }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "_put",
        value: function _put(path, body) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/collection/" + this.name + "/" + path,
                body: body
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/collection/" + this.name }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === exports.COLLECTION_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "create",
        value: function create(properties) {
            var _ref = properties || {},
                _ref$waitForSyncRepli = _ref.waitForSyncReplication,
                waitForSyncReplication = _ref$waitForSyncRepli === undefined ? undefined : _ref$waitForSyncRepli,
                _ref$enforceReplicati = _ref.enforceReplicationFactor,
                enforceReplicationFactor = _ref$enforceReplicati === undefined ? undefined : _ref$enforceReplicati,
                options = _objectWithoutProperties(_ref, ["waitForSyncReplication", "enforceReplicationFactor"]);

            var qs = {};
            if (typeof waitForSyncReplication === "boolean") {
                qs.waitForSyncReplication = waitForSyncReplication ? 1 : 0;
            }
            if (typeof enforceReplicationFactor === "boolean") {
                qs.enforceReplicationFactor = enforceReplicationFactor ? 1 : 0;
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/collection",
                qs: qs,
                body: _extends({}, options, {
                    name: this.name,
                    type: this.type
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "properties",
        value: function properties() {
            return this._get("properties");
        }
    }, {
        key: "count",
        value: function count() {
            return this._get("count");
        }
    }, {
        key: "figures",
        value: function figures() {
            return this._get("figures");
        }
    }, {
        key: "revision",
        value: function revision() {
            return this._get("revision");
        }
    }, {
        key: "checksum",
        value: function checksum(opts) {
            return this._get("checksum", opts);
        }
    }, {
        key: "load",
        value: function load(count) {
            return this._put("load", typeof count === "boolean" ? { count: count } : undefined);
        }
    }, {
        key: "unload",
        value: function unload() {
            return this._put("unload", undefined);
        }
    }, {
        key: "setProperties",
        value: function setProperties(properties) {
            return this._put("properties", properties);
        }
    }, {
        key: "rename",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
                var result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/collection/" + this.name + "/rename",
                                    body: { name: name }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context.sent;

                                this.name = name;
                                this._idPrefix = name + "/";
                                return _context.abrupt("return", result);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function rename(_x) {
                return _ref2.apply(this, arguments);
            }

            return rename;
        }()
    }, {
        key: "rotate",
        value: function rotate() {
            return this._put("rotate", undefined);
        }
    }, {
        key: "truncate",
        value: function truncate() {
            return this._put("truncate", undefined);
        }
    }, {
        key: "drop",
        value: function drop(opts) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/collection/" + this.name,
                qs: opts
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getResponsibleShard",
        value: function getResponsibleShard(document) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/collection/" + this.name + "/responsibleShard",
                body: document
            }, function (res) {
                return res.body.shardId;
            });
        }
    }, {
        key: "documentExists",
        value: function documentExists(documentHandle) {
            return this._connection.request({
                method: "HEAD",
                path: "/_api/" + this._documentPath(documentHandle)
            }, function () {
                return true;
            }).catch(function (err) {
                if (err.statusCode === 404) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "document",
        value: function document(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (typeof opts === "boolean") {
                opts = { graceful: opts };
            }
            var _opts = opts,
                _opts$allowDirtyRead = _opts.allowDirtyRead,
                allowDirtyRead = _opts$allowDirtyRead === undefined ? undefined : _opts$allowDirtyRead,
                _opts$graceful = _opts.graceful,
                graceful = _opts$graceful === undefined ? false : _opts$graceful;

            var result = this._connection.request({ path: "/_api/" + this._documentPath(documentHandle), allowDirtyRead: allowDirtyRead }, function (res) {
                return res.body;
            });
            if (!graceful) return result;
            return result.catch(function (err) {
                if (error_1.isArangoError(err) && err.errorNum === exports.DOCUMENT_NOT_FOUND) {
                    return null;
                }
                throw err;
            });
        }
    }, {
        key: "replace",
        value: function replace(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev && this._connection.arangoMajor >= 3) {
                var rev = void 0;
                var _opts2 = opts;
                rev = _opts2.rev;
                opts = _objectWithoutProperties(_opts2, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/" + this._documentPath(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "update",
        value: function update(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev && this._connection.arangoMajor >= 3) {
                var rev = void 0;
                var _opts3 = opts;
                rev = _opts3.rev;
                opts = _objectWithoutProperties(_opts3, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PATCH",
                path: "/_api/" + this._documentPath(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "bulkUpdate",
        value: function bulkUpdate(newValues, opts) {
            return this._connection.request({
                method: "PATCH",
                path: "/_api/document/" + this.name,
                body: newValues,
                qs: opts
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "remove",
        value: function remove(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev && this._connection.arangoMajor >= 3) {
                var rev = void 0;
                var _opts4 = opts;
                rev = _opts4.rev;
                opts = _objectWithoutProperties(_opts4, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/" + this._documentPath(documentHandle),
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "list",
        value: function list() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "id";

            if (this._connection.arangoMajor <= 2) {
                return this._connection.request({
                    path: "/_api/document",
                    qs: { type: type, collection: this.name }
                }, function (res) {
                    return res.body.documents;
                });
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/all-keys",
                body: { type: type, collection: this.name }
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "all",
        value: function all(opts) {
            var _this = this;

            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/all",
                body: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this._connection, res.body, res.arangojsHostId);
            });
        }
    }, {
        key: "any",
        value: function any() {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/any",
                body: { collection: this.name }
            }, function (res) {
                return res.body.document;
            });
        }
    }, {
        key: "first",
        value: function first(opts) {
            if (typeof opts === "number") {
                opts = { count: opts };
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/first",
                body: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "last",
        value: function last(opts) {
            if (typeof opts === "number") {
                opts = { count: opts };
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/last",
                body: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "byExample",
        value: function byExample(example, opts) {
            var _this2 = this;

            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/by-example",
                body: _extends({}, opts, {
                    example: example,
                    collection: this.name
                })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this2._connection, res.body, res.arangojsHostId);
            });
        }
    }, {
        key: "firstExample",
        value: function firstExample(example) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/first-example",
                body: {
                    example: example,
                    collection: this.name
                }
            }, function (res) {
                return res.body.document;
            });
        }
    }, {
        key: "removeByExample",
        value: function removeByExample(example, opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/remove-by-example",
                body: _extends({}, opts, {
                    example: example,
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "replaceByExample",
        value: function replaceByExample(example, newValue, opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/replace-by-example",
                body: _extends({}, opts, {
                    example: example,
                    newValue: newValue,
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "updateByExample",
        value: function updateByExample(example, newValue, opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/update-by-example",
                body: _extends({}, opts, {
                    example: example,
                    newValue: newValue,
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "lookupByKeys",
        value: function lookupByKeys(keys) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/lookup-by-keys",
                body: {
                    keys: keys,
                    collection: this.name
                }
            }, function (res) {
                return res.body.documents;
            });
        }
    }, {
        key: "removeByKeys",
        value: function removeByKeys(keys, options) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/remove-by-keys",
                body: {
                    options: options,
                    keys: keys,
                    collection: this.name
                }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "import",
        value: function _import(data) {
            var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var _ref3$type = _ref3.type,
                type = _ref3$type === undefined ? "auto" : _ref3$type,
                opts = _objectWithoutProperties(_ref3, ["type"]);

            if (Array.isArray(data)) {
                data = data.map(function (line) {
                    return JSON.stringify(line);
                }).join("\r\n") + "\r\n";
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/import",
                body: data,
                isBinary: true,
                qs: _extends({
                    type: type === null ? undefined : type
                }, opts, {
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "indexes",
        value: function indexes() {
            return this._connection.request({
                path: "/_api/index",
                qs: { collection: this.name }
            }, function (res) {
                return res.body.indexes;
            });
        }
    }, {
        key: "index",
        value: function index(indexHandle) {
            return this._connection.request({ path: "/_api/index/" + this._indexHandle(indexHandle) }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "ensureIndex",
        value: function ensureIndex(details) {
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: details,
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
        /** @deprecated use ensureIndex instead */

    }, {
        key: "createIndex",
        value: function createIndex(details) {
            return this.ensureIndex(details);
        }
    }, {
        key: "dropIndex",
        value: function dropIndex(indexHandle) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/index/" + this._indexHandle(indexHandle)
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createCapConstraint",
        value: function createCapConstraint(opts) {
            if (typeof opts === "number") {
                opts = { size: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({}, opts, { type: "cap" }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createHashIndex",
        value: function createHashIndex(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            if (typeof opts === "boolean") {
                opts = { unique: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({ unique: false }, opts, { type: "hash", fields: fields }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createSkipList",
        value: function createSkipList(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            if (typeof opts === "boolean") {
                opts = { unique: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({ unique: false }, opts, { type: "skiplist", fields: fields }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createPersistentIndex",
        value: function createPersistentIndex(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            if (typeof opts === "boolean") {
                opts = { unique: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({ unique: false }, opts, { type: "persistent", fields: fields }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createGeoIndex",
        value: function createGeoIndex(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({}, opts, { fields: fields, type: "geo" }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createFulltextIndex",
        value: function createFulltextIndex(fields, minLength) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: { fields: fields, minLength: minLength, type: "fulltext" },
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "fulltext",
        value: function fulltext(attribute, query) {
            var _this3 = this;

            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (opts.index) opts.index = this._indexHandle(opts.index);
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/fulltext",
                body: _extends({}, opts, {
                    attribute: attribute,
                    query: query,
                    collection: this.name
                })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this3._connection, res.body, res.arangojsHostId);
            });
        }
    }]);

    return BaseCollection;
}();

exports.BaseCollection = BaseCollection;

var DocumentCollection = function (_BaseCollection) {
    _inherits(DocumentCollection, _BaseCollection);

    function DocumentCollection(connection, name) {
        _classCallCheck(this, DocumentCollection);

        var _this4 = _possibleConstructorReturn(this, (DocumentCollection.__proto__ || Object.getPrototypeOf(DocumentCollection)).call(this, connection, name));

        _this4.type = CollectionType.DOCUMENT_COLLECTION;
        return _this4;
    }

    _createClass(DocumentCollection, [{
        key: "save",
        value: function save(data, opts) {
            if (typeof opts === "boolean") {
                opts = { returnNew: opts };
            }
            if (this._connection.arangoMajor <= 2) {
                return this._connection.request({
                    method: "POST",
                    path: "/_api/document",
                    body: data,
                    qs: _extends({}, opts, {
                        collection: this.name
                    })
                }, function (res) {
                    return res.body;
                });
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/document/" + this.name,
                body: data,
                qs: opts
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return DocumentCollection;
}(BaseCollection);

exports.DocumentCollection = DocumentCollection;

var EdgeCollection = function (_BaseCollection2) {
    _inherits(EdgeCollection, _BaseCollection2);

    function EdgeCollection(connection, name) {
        _classCallCheck(this, EdgeCollection);

        var _this5 = _possibleConstructorReturn(this, (EdgeCollection.__proto__ || Object.getPrototypeOf(EdgeCollection)).call(this, connection, name));

        _this5.type = CollectionType.EDGE_COLLECTION;
        return _this5;
    }

    _createClass(EdgeCollection, [{
        key: "_documentPath",
        value: function _documentPath(documentHandle) {
            if (this._connection.arangoMajor < 3) {
                return "edge/" + this._documentHandle(documentHandle);
            }
            return "document/" + this._documentHandle(documentHandle);
        }
    }, {
        key: "edge",
        value: function edge(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (typeof opts === "boolean") {
                opts = { graceful: opts };
            }
            return this.document(documentHandle, opts);
        }
    }, {
        key: "save",
        value: function save(data, fromIdOrOpts, toId, opts) {
            if (toId !== undefined) {
                var fromId = this._documentHandle(fromIdOrOpts);
                toId = this._documentHandle(toId);
                if (Array.isArray(data)) {
                    data = data.map(function (data) {
                        return Object.assign(data, { _from: fromId, _to: toId });
                    });
                } else {
                    data = Object.assign(data, { _from: fromId, _to: toId });
                }
            } else {
                if (fromIdOrOpts !== undefined) {
                    opts = fromIdOrOpts;
                }
            }
            if (typeof opts === "boolean") {
                opts = { returnNew: opts };
            }
            if (this._connection.arangoMajor <= 2) {
                if (Array.isArray(data)) {
                    throw new Error("ArangoDB 2 does not support batch operations");
                }
                return this._connection.request({
                    method: "POST",
                    path: "/_api/edge",
                    body: data,
                    qs: _extends({}, opts, {
                        collection: this.name,
                        from: data._from,
                        to: data._to
                    })
                }, function (res) {
                    return res.body;
                });
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/document",
                body: data,
                qs: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "_edges",
        value: function _edges(documentHandle, direction) {
            return this._connection.request({
                path: "/_api/edges/" + this.name,
                qs: {
                    direction: direction,
                    vertex: this._documentHandle(documentHandle)
                }
            }, function (res) {
                return res.body.edges;
            });
        }
    }, {
        key: "edges",
        value: function edges(vertex) {
            return this._edges(vertex);
        }
    }, {
        key: "inEdges",
        value: function inEdges(vertex) {
            return this._edges(vertex, "in");
        }
    }, {
        key: "outEdges",
        value: function outEdges(vertex) {
            return this._edges(vertex, "out");
        }
    }, {
        key: "traversal",
        value: function traversal(startVertex, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/traversal",
                body: _extends({}, opts, {
                    startVertex: startVertex,
                    edgeCollection: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }]);

    return EdgeCollection;
}(BaseCollection);

exports.EdgeCollection = EdgeCollection;
function constructCollection(connection, data) {
    var Collection = data.type === CollectionType.EDGE_COLLECTION ? EdgeCollection : DocumentCollection;
    return new Collection(connection, data.name);
}
exports.constructCollection = constructCollection;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(42);

module.exports = Function.prototype.bind || implementation;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) {
			return false;
		}
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isCallable(value) {
	if (!value) {
		return false;
	}
	if (typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
		return false;
	}
	if (typeof value === 'function' && !value.prototype) {
		return true;
	}
	if (hasToStringTag) {
		return tryFunctionObject(value);
	}
	if (isES6ClassFn(value)) {
		return false;
	}
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _templateObject = _taggedTemplateLiteral([""], [""]),
    _templateObject2 = _taggedTemplateLiteral(["", ""], ["", ""]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = __webpack_require__(1);
function isAqlQuery(query) {
    return Boolean(query && typeof query.query === "string" && query.bindVars);
}
exports.isAqlQuery = isAqlQuery;
function isGeneratedAqlQuery(query) {
    return isAqlQuery(query) && typeof query._source === "function";
}
exports.isGeneratedAqlQuery = isGeneratedAqlQuery;
function isAqlLiteral(literal) {
    return Boolean(literal && typeof literal.toAQL === "function");
}
exports.isAqlLiteral = isAqlLiteral;
function aql(templateStrings) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    var strings = [].concat(_toConsumableArray(templateStrings));
    var bindVars = {};
    var bindVals = [];
    var query = strings[0];
    for (var i = 0; i < args.length; i++) {
        var rawValue = args[i];
        var value = rawValue;
        if (isGeneratedAqlQuery(rawValue)) {
            var src = rawValue._source();
            if (src.args.length) {
                query += src.strings[0];
                args.splice.apply(args, [i, 1].concat(_toConsumableArray(src.args)));
                strings.splice.apply(strings, [i, 2, strings[i] + src.strings[0]].concat(_toConsumableArray(src.strings.slice(1, src.args.length)), [src.strings[src.args.length] + strings[i + 1]]));
            } else {
                query += rawValue.query + strings[i + 1];
                args.splice(i, 1);
                strings.splice(i, 2, strings[i] + rawValue.query + strings[i + 1]);
            }
            i -= 1;
            continue;
        }
        if (rawValue === undefined) {
            query += strings[i + 1];
            continue;
        }
        if (isAqlLiteral(rawValue)) {
            query += "" + rawValue.toAQL() + strings[i + 1];
            continue;
        }
        var index = bindVals.indexOf(rawValue);
        var isKnown = index !== -1;
        var name = "value" + (isKnown ? index : bindVals.length);
        if (collection_1.isArangoCollection(rawValue)) {
            name = "@" + name;
            value = rawValue.name;
        }
        if (!isKnown) {
            bindVals.push(rawValue);
            bindVars[name] = value;
        }
        query += "@" + name + strings[i + 1];
    }
    return {
        query: query,
        bindVars: bindVars,
        _source: function _source() {
            return { strings: strings, args: args };
        }
    };
}
exports.aql = aql;
(function (aql) {
    aql.literal = function (value) {
        if (isAqlLiteral(value)) {
            return value;
        }
        return {
            toAQL: function toAQL() {
                if (value === undefined) {
                    return "";
                }
                return String(value);
            }
        };
    };
    aql.join = function (values) {
        var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";

        if (!values.length) {
            return aql(_templateObject);
        }
        if (values.length === 1) {
            return aql(_templateObject2, values[0]);
        }
        return aql.apply(undefined, [[""].concat(_toConsumableArray(Array(values.length - 1).fill(sep)), [""])].concat(_toConsumableArray(values)));
    };
})(aql = exports.aql || (exports.aql = {}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var ArrayCursor = function () {
    function ArrayCursor(connection, body, host, allowDirtyRead) {
        _classCallCheck(this, ArrayCursor);

        this.extra = body.extra;
        this._connection = connection;
        this._result = body.result;
        this._id = body.id;
        this._hasMore = Boolean(body.id && body.hasMore);
        this._host = host;
        this.count = body.count;
        this._allowDirtyRead = allowDirtyRead;
    }

    _createClass(ArrayCursor, [{
        key: "_drain",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._more();

                            case 2:
                                if (this._hasMore) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt("return", this);

                            case 4:
                                return _context.abrupt("return", this._drain());

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _drain() {
                return _ref.apply(this, arguments);
            }

            return _drain;
        }()
    }, {
        key: "_more",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _result, res;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this._hasMore) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 4:
                                _context2.next = 6;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/cursor/" + this._id,
                                    host: this._host,
                                    allowDirtyRead: this._allowDirtyRead
                                });

                            case 6:
                                res = _context2.sent;

                                (_result = this._result).push.apply(_result, _toConsumableArray(res.body.result));
                                this._hasMore = res.body.hasMore;

                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _more() {
                return _ref2.apply(this, arguments);
            }

            return _more;
        }()
    }, {
        key: "all",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var result;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this._drain();

                            case 2:
                                result = this._result;

                                this._result = [];
                                return _context3.abrupt("return", result);

                            case 5:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function all() {
                return _ref3.apply(this, arguments);
            }

            return all;
        }()
    }, {
        key: "next",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(!this._result.length && this._hasMore)) {
                                    _context4.next = 5;
                                    break;
                                }

                                _context4.next = 3;
                                return this._more();

                            case 3:
                                _context4.next = 0;
                                break;

                            case 5:
                                if (this._result.length) {
                                    _context4.next = 7;
                                    break;
                                }

                                return _context4.abrupt("return", undefined);

                            case 7:
                                return _context4.abrupt("return", this._result.shift());

                            case 8:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function next() {
                return _ref4.apply(this, arguments);
            }

            return next;
        }()
    }, {
        key: "hasNext",
        value: function hasNext() {
            return Boolean(this._hasMore || this._result.length);
        }
    }, {
        key: "nextBatch",
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(!this._result.length && this._hasMore)) {
                                    _context5.next = 5;
                                    break;
                                }

                                _context5.next = 3;
                                return this._more();

                            case 3:
                                _context5.next = 0;
                                break;

                            case 5:
                                if (this._result.length) {
                                    _context5.next = 7;
                                    break;
                                }

                                return _context5.abrupt("return", undefined);

                            case 7:
                                return _context5.abrupt("return", this._result.splice(0, this._result.length));

                            case 8:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function nextBatch() {
                return _ref5.apply(this, arguments);
            }

            return nextBatch;
        }()
    }, {
        key: "each",
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                index = 0;

                            case 1:
                                if (!(this._result.length || this._hasMore)) {
                                    _context6.next = 15;
                                    break;
                                }

                                result = void 0;

                            case 3:
                                if (!this._result.length) {
                                    _context6.next = 10;
                                    break;
                                }

                                result = fn(this._result.shift(), index, this);
                                index++;

                                if (!(result === false)) {
                                    _context6.next = 8;
                                    break;
                                }

                                return _context6.abrupt("return", result);

                            case 8:
                                _context6.next = 3;
                                break;

                            case 10:
                                if (!this._hasMore) {
                                    _context6.next = 13;
                                    break;
                                }

                                _context6.next = 13;
                                return this._more();

                            case 13:
                                _context6.next = 1;
                                break;

                            case 15:
                                return _context6.abrupt("return", true);

                            case 16:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function each(_x) {
                return _ref6.apply(this, arguments);
            }

            return each;
        }()
    }, {
        key: "every",
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                index = 0;

                            case 1:
                                if (!(this._result.length || this._hasMore)) {
                                    _context7.next = 15;
                                    break;
                                }

                                result = void 0;

                            case 3:
                                if (!this._result.length) {
                                    _context7.next = 10;
                                    break;
                                }

                                result = fn(this._result.shift(), index, this);
                                index++;

                                if (result) {
                                    _context7.next = 8;
                                    break;
                                }

                                return _context7.abrupt("return", false);

                            case 8:
                                _context7.next = 3;
                                break;

                            case 10:
                                if (!this._hasMore) {
                                    _context7.next = 13;
                                    break;
                                }

                                _context7.next = 13;
                                return this._more();

                            case 13:
                                _context7.next = 1;
                                break;

                            case 15:
                                return _context7.abrupt("return", true);

                            case 16:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function every(_x2) {
                return _ref7.apply(this, arguments);
            }

            return every;
        }()
    }, {
        key: "some",
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                index = 0;

                            case 1:
                                if (!(this._result.length || this._hasMore)) {
                                    _context8.next = 15;
                                    break;
                                }

                                result = void 0;

                            case 3:
                                if (!this._result.length) {
                                    _context8.next = 10;
                                    break;
                                }

                                result = fn(this._result.shift(), index, this);
                                index++;

                                if (!result) {
                                    _context8.next = 8;
                                    break;
                                }

                                return _context8.abrupt("return", true);

                            case 8:
                                _context8.next = 3;
                                break;

                            case 10:
                                if (!this._hasMore) {
                                    _context8.next = 13;
                                    break;
                                }

                                _context8.next = 13;
                                return this._more();

                            case 13:
                                _context8.next = 1;
                                break;

                            case 15:
                                return _context8.abrupt("return", false);

                            case 16:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function some(_x3) {
                return _ref8.apply(this, arguments);
            }

            return some;
        }()
    }, {
        key: "map",
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                index = 0;
                                result = [];

                            case 2:
                                if (!(this._result.length || this._hasMore)) {
                                    _context9.next = 9;
                                    break;
                                }

                                while (this._result.length) {
                                    result.push(fn(this._result.shift(), index, this));
                                    index++;
                                }

                                if (!this._hasMore) {
                                    _context9.next = 7;
                                    break;
                                }

                                _context9.next = 7;
                                return this._more();

                            case 7:
                                _context9.next = 2;
                                break;

                            case 9:
                                return _context9.abrupt("return", result);

                            case 10:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function map(_x4) {
                return _ref9.apply(this, arguments);
            }

            return map;
        }()
    }, {
        key: "reduce",
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(fn, accu) {
                var index;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                index = 0;

                                if (!(accu === undefined)) {
                                    _context10.next = 7;
                                    break;
                                }

                                if (!(!this._result.length && !this._hasMore)) {
                                    _context10.next = 5;
                                    break;
                                }

                                _context10.next = 5;
                                return this._more();

                            case 5:
                                accu = this._result.shift();
                                index += 1;

                            case 7:
                                if (!(this._result.length || this._hasMore)) {
                                    _context10.next = 14;
                                    break;
                                }

                                while (this._result.length) {
                                    accu = fn(accu, this._result.shift(), index, this);
                                    index++;
                                }

                                if (!this._hasMore) {
                                    _context10.next = 12;
                                    break;
                                }

                                _context10.next = 12;
                                return this._more();

                            case 12:
                                _context10.next = 7;
                                break;

                            case 14:
                                return _context10.abrupt("return", accu);

                            case 15:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function reduce(_x5, _x6) {
                return _ref10.apply(this, arguments);
            }

            return reduce;
        }()
    }, {
        key: "kill",
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var _this = this;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (this._hasMore) {
                                    _context11.next = 2;
                                    break;
                                }

                                return _context11.abrupt("return", undefined);

                            case 2:
                                return _context11.abrupt("return", this._connection.request({
                                    method: "DELETE",
                                    path: "/_api/cursor/" + this._id
                                }, function () {
                                    _this._hasMore = false;
                                    return undefined;
                                }));

                            case 3:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function kill() {
                return _ref11.apply(this, arguments);
            }

            return kill;
        }()
    }]);

    return ArrayCursor;
}();

exports.ArrayCursor = ArrayCursor;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(27);
exports.encode = exports.stringify = __webpack_require__(28);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keys = __webpack_require__(43);
var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol('foo')) === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function isFunction(fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) {
			// jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) {
		/* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function defineProperty(object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function defineProperties(object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' && value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(2);
var ES = __webpack_require__(45);
var replace = bind.call(Function.call, String.prototype.replace);

/* eslint-disable no-control-regex */
var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Set,
	Map,
	WeakSet,
	WeakMap,

	Promise,

	Symbol,
	Proxy,

	Atomics,
	SharedArrayBuffer,

	ArrayBuffer,
	DataView,
	Uint8Array,
	Float32Array,
	Float64Array,
	Int8Array,
	Int16Array,
	Int32Array,
	Uint8ClampedArray,
	Uint16Array,
	Uint32Array,
*/

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var undefined; // eslint-disable-line no-shadow-restricted-names

var ThrowTypeError = Object.getOwnPropertyDescriptor ? function () {
	return Object.getOwnPropertyDescriptor(arguments, 'callee').get;
}() : function () {
	throw new TypeError();
};

var hasSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol';

var getProto = Object.getPrototypeOf || function (x) {
	return x.__proto__;
}; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'$ %Array%': Array,
	'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'$ %ArrayPrototype%': Array.prototype,
	'$ %ArrayProto_entries%': Array.prototype.entries,
	'$ %ArrayProto_forEach%': Array.prototype.forEach,
	'$ %ArrayProto_keys%': Array.prototype.keys,
	'$ %ArrayProto_values%': Array.prototype.values,
	'$ %AsyncFromSyncIteratorPrototype%': undefined,
	'$ %AsyncFunction%': asyncFunction,
	'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'$ %AsyncGeneratorFunction%': asyncGenFunction,
	'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'$ %Boolean%': Boolean,
	'$ %BooleanPrototype%': Boolean.prototype,
	'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'$ %Date%': Date,
	'$ %DatePrototype%': Date.prototype,
	'$ %decodeURI%': decodeURI,
	'$ %decodeURIComponent%': decodeURIComponent,
	'$ %encodeURI%': encodeURI,
	'$ %encodeURIComponent%': encodeURIComponent,
	'$ %Error%': Error,
	'$ %ErrorPrototype%': Error.prototype,
	'$ %eval%': eval, // eslint-disable-line no-eval
	'$ %EvalError%': EvalError,
	'$ %EvalErrorPrototype%': EvalError.prototype,
	'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'$ %Function%': Function,
	'$ %FunctionPrototype%': Function.prototype,
	'$ %Generator%': generator ? getProto(generator()) : undefined,
	'$ %GeneratorFunction%': generatorFunction,
	'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'$ %isFinite%': isFinite,
	'$ %isNaN%': isNaN,
	'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'$ %JSON%': JSON,
	'$ %JSONParse%': JSON.parse,
	'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
	'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'$ %Math%': Math,
	'$ %Number%': Number,
	'$ %NumberPrototype%': Number.prototype,
	'$ %Object%': Object,
	'$ %ObjectPrototype%': Object.prototype,
	'$ %ObjProto_toString%': Object.prototype.toString,
	'$ %ObjProto_valueOf%': Object.prototype.valueOf,
	'$ %parseFloat%': parseFloat,
	'$ %parseInt%': parseInt,
	'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'$ %RangeError%': RangeError,
	'$ %RangeErrorPrototype%': RangeError.prototype,
	'$ %ReferenceError%': ReferenceError,
	'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
	'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'$ %RegExp%': RegExp,
	'$ %RegExpPrototype%': RegExp.prototype,
	'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
	'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'$ %String%': String,
	'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'$ %StringPrototype%': String.prototype,
	'$ %Symbol%': hasSymbols ? Symbol : undefined,
	'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'$ %SyntaxError%': SyntaxError,
	'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
	'$ %ThrowTypeError%': ThrowTypeError,
	'$ %TypedArray%': TypedArray,
	'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'$ %TypeError%': TypeError,
	'$ %TypeErrorPrototype%': TypeError.prototype,
	'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'$ %URIError%': URIError,
	'$ %URIErrorPrototype%': URIError.prototype,
	'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var key = '$ ' + name;
	if (!(key in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
		throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}
	return INTRINSICS[key];
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(2);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(12);

var zeroWidthSpace = '\u200B';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents an Item within LinkedList
 * An item holds a value and the links to other LinkedListItem's
 * LinkedListItem's can only be attached behind.
 * Theirfor, to add one before, before has to add one behind.
 */

var LinkedListItem = function () {
    function LinkedListItem(value,
    /**
     * Called on unlink. Usually used by LinkedList to fix first and last pointers and reduce length.
     */
    unlinkCleanup) {
        _classCallCheck(this, LinkedListItem);

        this.value = value;
        this.unlinkCleanup = unlinkCleanup;
    }
    /**
     * This will link given LinkListItem behind this item.
     * If there's already a LinkedListItem linked behind, it will be relinked accordingly
     * @param item LinkListItem to be inserted behind this one
     */


    _createClass(LinkedListItem, [{
        key: "insertBehind",
        value: function insertBehind(item) {
            item.insertBefore(this);
            if (this.behind) {
                var itemChainEnd = item;
                while (itemChainEnd.behind) {
                    itemChainEnd = itemChainEnd.behind;
                }
                this.behind.insertBefore(itemChainEnd);
                itemChainEnd.insertBehind(this.behind);
            }
            this.behind = item;
        }
        /**
         * Unlinks this LinkedListItem and calls unlinkCleanup
         * @see LinkedListItem#unlinkCleanup
         */

    }, {
        key: "unlink",
        value: function unlink() {
            if (this.before) {
                this.before.behind = this.behind;
            }
            if (this.behind) {
                this.behind.before = this.before;
            }
            if (this.unlinkCleanup) {
                this.unlinkCleanup(this);
            }
            this.unlinkCleanup = undefined;
        }
        /**
         * Item given will be inserted before this item.
         * unlinkCleanup will be copied if neccessary.
         * This function is protected, because LinkedListItem's can only be attached behind.
         *
         * @param before
         * @see insertBehind
         */

    }, {
        key: "insertBefore",
        value: function insertBefore(before) {
            this.before = before;
            if (!this.unlinkCleanup) {
                this.unlinkCleanup = before.unlinkCleanup;
            }
        }
    }]);

    return LinkedListItem;
}();

exports.LinkedListItem = LinkedListItem;
//# sourceMappingURL=LinkedListItem.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = __webpack_require__(1);
var error_1 = __webpack_require__(0);

var GraphVertexCollection = function (_collection_1$BaseCol) {
    _inherits(GraphVertexCollection, _collection_1$BaseCol);

    function GraphVertexCollection(connection, name, graph) {
        _classCallCheck(this, GraphVertexCollection);

        var _this = _possibleConstructorReturn(this, (GraphVertexCollection.__proto__ || Object.getPrototypeOf(GraphVertexCollection)).call(this, connection, name));

        _this.type = collection_1.CollectionType.DOCUMENT_COLLECTION;
        _this.graph = graph;
        return _this;
    }

    _createClass(GraphVertexCollection, [{
        key: "document",
        value: function document(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (typeof opts === "boolean") {
                opts = { graceful: opts };
            }
            var _opts = opts,
                _opts$allowDirtyRead = _opts.allowDirtyRead,
                allowDirtyRead = _opts$allowDirtyRead === undefined ? undefined : _opts$allowDirtyRead,
                _opts$graceful = _opts.graceful,
                graceful = _opts$graceful === undefined ? false : _opts$graceful;

            var result = this._connection.request({
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                allowDirtyRead: allowDirtyRead
            }, function (res) {
                return res.body.vertex;
            });
            if (!graceful) return result;
            return result.catch(function (err) {
                if (error_1.isArangoError(err) && err.errorNum === collection_1.DOCUMENT_NOT_FOUND) {
                    return null;
                }
                throw err;
            });
        }
    }, {
        key: "vertex",
        value: function vertex(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (typeof opts === "boolean") {
                opts = { graceful: opts };
            }
            return this.document(documentHandle, opts);
        }
    }, {
        key: "save",
        value: function save(data, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this.name,
                body: data,
                qs: opts
            }, function (res) {
                return res.body.vertex;
            });
        }
    }, {
        key: "replace",
        value: function replace(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts2 = opts;
                rev = _opts2.rev;
                opts = _objectWithoutProperties(_opts2, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.vertex;
            });
        }
    }, {
        key: "update",
        value: function update(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts3 = opts;
                rev = _opts3.rev;
                opts = _objectWithoutProperties(_opts3, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PATCH",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.vertex;
            });
        }
    }, {
        key: "remove",
        value: function remove(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts4 = opts;
                rev = _opts4.rev;
                opts = _objectWithoutProperties(_opts4, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.removed;
            });
        }
    }]);

    return GraphVertexCollection;
}(collection_1.BaseCollection);

exports.GraphVertexCollection = GraphVertexCollection;

var GraphEdgeCollection = function (_collection_1$EdgeCol) {
    _inherits(GraphEdgeCollection, _collection_1$EdgeCol);

    function GraphEdgeCollection(connection, name, graph) {
        _classCallCheck(this, GraphEdgeCollection);

        var _this2 = _possibleConstructorReturn(this, (GraphEdgeCollection.__proto__ || Object.getPrototypeOf(GraphEdgeCollection)).call(this, connection, name));

        _this2.type = collection_1.CollectionType.EDGE_COLLECTION;
        _this2.type = collection_1.CollectionType.EDGE_COLLECTION;
        _this2.graph = graph;
        return _this2;
    }

    _createClass(GraphEdgeCollection, [{
        key: "document",
        value: function document(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (typeof opts === "boolean") {
                opts = { graceful: opts };
            }
            var _opts5 = opts,
                _opts5$allowDirtyRead = _opts5.allowDirtyRead,
                allowDirtyRead = _opts5$allowDirtyRead === undefined ? undefined : _opts5$allowDirtyRead,
                _opts5$graceful = _opts5.graceful,
                graceful = _opts5$graceful === undefined ? false : _opts5$graceful;

            var result = this._connection.request({
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                allowDirtyRead: allowDirtyRead
            }, function (res) {
                return res.body.edge;
            });
            if (!graceful) return result;
            return result.catch(function (err) {
                if (error_1.isArangoError(err) && err.errorNum === collection_1.DOCUMENT_NOT_FOUND) {
                    return null;
                }
                throw err;
            });
        }
    }, {
        key: "save",
        value: function save(data, fromIdOrOpts, toId, opts) {
            if (toId !== undefined) {
                var fromId = this._documentHandle(fromIdOrOpts);
                toId = this._documentHandle(toId);
                if (Array.isArray(data)) {
                    data = data.map(function (data) {
                        return _extends({}, data, { _from: fromId, _to: toId });
                    });
                } else {
                    data = _extends({}, data, { _from: fromId, _to: toId });
                }
            } else {
                if (fromIdOrOpts !== undefined) {
                    opts = fromIdOrOpts;
                }
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this.name,
                body: data,
                qs: opts
            }, function (res) {
                return res.body.edge;
            });
        }
    }, {
        key: "replace",
        value: function replace(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts6 = opts;
                rev = _opts6.rev;
                opts = _objectWithoutProperties(_opts6, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.edge;
            });
        }
    }, {
        key: "update",
        value: function update(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts7 = opts;
                rev = _opts7.rev;
                opts = _objectWithoutProperties(_opts7, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PATCH",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.edge;
            });
        }
    }, {
        key: "remove",
        value: function remove(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts8 = opts;
                rev = _opts8.rev;
                opts = _objectWithoutProperties(_opts8, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.removed;
            });
        }
    }]);

    return GraphEdgeCollection;
}(collection_1.EdgeCollection);

exports.GraphEdgeCollection = GraphEdgeCollection;
var GRAPH_NOT_FOUND = 1924;

var Graph = function () {
    function Graph(connection, name) {
        _classCallCheck(this, Graph);

        this.name = name;
        this._connection = connection;
    }

    _createClass(Graph, [{
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/gharial/" + this.name }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === GRAPH_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "create",
        value: function create() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opts = arguments[1];

            return this._connection.request({
                method: "POST",
                path: "/_api/gharial",
                body: _extends({}, properties, {
                    name: this.name
                }),
                qs: opts
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "drop",
        value: function drop() {
            var dropCollections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.name,
                qs: { dropCollections: dropCollections }
            }, function (res) {
                return res.body.removed;
            });
        }
    }, {
        key: "vertexCollection",
        value: function vertexCollection(collectionName) {
            return new GraphVertexCollection(this._connection, collectionName, this);
        }
    }, {
        key: "listVertexCollections",
        value: function listVertexCollections(opts) {
            return this._connection.request({ path: "/_api/gharial/" + this.name + "/vertex", qs: opts }, function (res) {
                return res.body.collections;
            });
        }
    }, {
        key: "vertexCollections",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opts) {
                var _this3 = this;

                var names;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.listVertexCollections(opts);

                            case 2:
                                names = _context.sent;
                                return _context.abrupt("return", names.map(function (name) {
                                    return new GraphVertexCollection(_this3._connection, name, _this3);
                                }));

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function vertexCollections(_x12) {
                return _ref.apply(this, arguments);
            }

            return vertexCollections;
        }()
    }, {
        key: "addVertexCollection",
        value: function addVertexCollection(collection) {
            if (collection_1.isArangoCollection(collection)) {
                collection = collection.name;
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.name + "/vertex",
                body: { collection: collection }
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "removeVertexCollection",
        value: function removeVertexCollection(collection) {
            var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (collection_1.isArangoCollection(collection)) {
                collection = collection.name;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.name + "/vertex/" + collection,
                qs: {
                    dropCollection: dropCollection
                }
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "edgeCollection",
        value: function edgeCollection(collectionName) {
            return new GraphEdgeCollection(this._connection, collectionName, this);
        }
    }, {
        key: "listEdgeCollections",
        value: function listEdgeCollections() {
            return this._connection.request({ path: "/_api/gharial/" + this.name + "/edge" }, function (res) {
                return res.body.collections;
            });
        }
    }, {
        key: "edgeCollections",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this4 = this;

                var names;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.listEdgeCollections();

                            case 2:
                                names = _context2.sent;
                                return _context2.abrupt("return", names.map(function (name) {
                                    return new GraphEdgeCollection(_this4._connection, name, _this4);
                                }));

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function edgeCollections() {
                return _ref2.apply(this, arguments);
            }

            return edgeCollections;
        }()
    }, {
        key: "addEdgeDefinition",
        value: function addEdgeDefinition(definition) {
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.name + "/edge",
                body: definition
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "replaceEdgeDefinition",
        value: function replaceEdgeDefinition(definitionName, definition) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/gharial/" + this.name + "/edge/" + definitionName,
                body: definition
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "removeEdgeDefinition",
        value: function removeEdgeDefinition(definitionName) {
            var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.name + "/edge/" + definitionName,
                qs: {
                    dropCollection: dropCollection
                }
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "traversal",
        value: function traversal(startVertex, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/traversal",
                body: _extends({}, opts, {
                    startVertex: startVertex,
                    graphName: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }]);

    return Graph;
}();

exports.Graph = Graph;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
module.exports = __webpack_require__(20);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
function () {
  return this;
}() || Function("return this")());
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(21).default;
module.exports.default = module.exports;
Object.defineProperty(module.exports, "__esModule", { value: true });

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var aql_query_1 = __webpack_require__(5);
exports.aql = aql_query_1.aql;
var collection_1 = __webpack_require__(1);
var database_1 = __webpack_require__(24);
exports.Database = database_1.Database;
var error_1 = __webpack_require__(0);
function arangojs(config) {
    return new database_1.Database(config);
}
exports.default = arangojs;
Object.assign(arangojs, { CollectionType: collection_1.CollectionType, ArangoError: error_1.ArangoError, Database: database_1.Database, aql: aql_query_1.aql });
var collection_2 = __webpack_require__(1);
exports.DocumentCollection = collection_2.DocumentCollection;
exports.EdgeCollection = collection_2.EdgeCollection;
var graph_1 = __webpack_require__(17);
exports.Graph = graph_1.Graph;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var ExtendableError = __webpack_require__(23);
ExtendableError = ExtendableError.default || ExtendableError;
exports.default = ExtendableError;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

exports.default = ExtendableError;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var analyzer_1 = __webpack_require__(25);
var aql_query_1 = __webpack_require__(5);
var collection_1 = __webpack_require__(1);
var connection_1 = __webpack_require__(26);
var cursor_1 = __webpack_require__(6);
var error_1 = __webpack_require__(0);
var graph_1 = __webpack_require__(17);
var route_1 = __webpack_require__(59);
var transaction_1 = __webpack_require__(60);
var btoa_1 = __webpack_require__(61);
var multipart_1 = __webpack_require__(62);
var view_1 = __webpack_require__(63);
function colToString(collection) {
    if (collection_1.isArangoCollection(collection)) {
        return String(collection.name);
    } else return String(collection);
}
var DATABASE_NOT_FOUND = 1228;

var Database = function () {
    function Database(config) {
        _classCallCheck(this, Database);

        this._connection = new connection_1.Connection(config);
    }

    _createClass(Database, [{
        key: "version",

        //#region misc
        value: function version() {
            return this._connection.request({
                method: "GET",
                path: "/_api/version"
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "route",
        value: function route(path, headers) {
            return new route_1.Route(this._connection, path, headers);
        }
    }, {
        key: "acquireHostList",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var urls;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this._connection.getDatabaseName()) {
                                    _context.next = 2;
                                    break;
                                }

                                throw new Error("Cannot acquire host list with absolute URL");

                            case 2:
                                _context.next = 4;
                                return this._connection.request({ path: "/_api/cluster/endpoints" }, function (res) {
                                    return res.body.endpoints.map(function (endpoint) {
                                        return endpoint.endpoint;
                                    });
                                });

                            case 4:
                                urls = _context.sent;

                                this._connection.addToHostList(urls);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function acquireHostList() {
                return _ref.apply(this, arguments);
            }

            return acquireHostList;
        }()
    }, {
        key: "close",
        value: function close() {
            this._connection.close();
        }
        //#endregion
        //#region auth

    }, {
        key: "login",
        value: function login() {
            var _this = this;

            var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "root";
            var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            return this._connection.request({
                method: "POST",
                path: "/_open/auth",
                body: { username: username, password: password }
            }, function (res) {
                _this.useBearerAuth(res.body.jwt);
                return res.body.jwt;
            });
        }
    }, {
        key: "useBearerAuth",
        value: function useBearerAuth(token) {
            this._connection.setHeader("authorization", "Bearer " + token);
            return this;
        }
    }, {
        key: "useBasicAuth",
        value: function useBasicAuth() {
            var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "root";
            var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this._connection.setHeader("authorization", "Basic " + btoa_1.btoa(username + ":" + password));
            return this;
        }
        //#endregion
        //#region databases

    }, {
        key: "useDatabase",
        value: function useDatabase(databaseName) {
            this._connection.setDatabaseName(databaseName);
            return this;
        }
    }, {
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/database/current" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === DATABASE_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "createDatabase",
        value: function createDatabase(databaseName, users) {
            return this._connection.request({
                method: "POST",
                path: "/_api/database",
                body: { users: users, name: databaseName }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "listDatabases",
        value: function listDatabases() {
            return this._connection.request({ path: "/_api/database" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "listUserDatabases",
        value: function listUserDatabases() {
            return this._connection.request({ path: "/_api/database/user" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "dropDatabase",
        value: function dropDatabase(databaseName) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/database/" + databaseName
            }, function (res) {
                return res.body;
            });
        }
        //#endregion
        //#region collections

    }, {
        key: "collection",
        value: function collection(collectionName) {
            return new collection_1.DocumentCollection(this._connection, collectionName);
        }
    }, {
        key: "edgeCollection",
        value: function edgeCollection(collectionName) {
            return new collection_1.EdgeCollection(this._connection, collectionName);
        }
    }, {
        key: "listCollections",
        value: function listCollections() {
            var _this2 = this;

            var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return this._connection.request({
                path: "/_api/collection",
                qs: { excludeSystem: excludeSystem }
            }, function (res) {
                return _this2._connection.arangoMajor <= 2 ? res.body.collections : res.body.result;
            });
        }
    }, {
        key: "collections",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var collections;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.listCollections(excludeSystem);

                            case 2:
                                collections = _context2.sent;
                                return _context2.abrupt("return", collections.map(function (data) {
                                    return collection_1.constructCollection(_this3._connection, data);
                                }));

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function collections() {
                return _ref2.apply(this, arguments);
            }

            return collections;
        }()
    }, {
        key: "truncate",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this4 = this;

                var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var collections;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.listCollections(excludeSystem);

                            case 2:
                                collections = _context3.sent;
                                _context3.next = 5;
                                return Promise.all(collections.map(function (data) {
                                    return _this4._connection.request({
                                        method: "PUT",
                                        path: "/_api/collection/" + data.name + "/truncate"
                                    }, function (res) {
                                        return res.body;
                                    });
                                }));

                            case 5:
                                return _context3.abrupt("return", _context3.sent);

                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function truncate() {
                return _ref3.apply(this, arguments);
            }

            return truncate;
        }()
        //#endregion
        //#region views

    }, {
        key: "arangoSearchView",
        value: function arangoSearchView(viewName) {
            return new view_1.ArangoSearchView(this._connection, viewName);
        }
    }, {
        key: "listViews",
        value: function listViews() {
            return this._connection.request({ path: "/_api/view" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "views",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _this5 = this;

                var views;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.listViews();

                            case 2:
                                views = _context4.sent;
                                return _context4.abrupt("return", views.map(function (data) {
                                    return view_1.constructView(_this5._connection, data);
                                }));

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function views() {
                return _ref4.apply(this, arguments);
            }

            return views;
        }()
        //#endregion
        //#region analyzers

    }, {
        key: "analyzer",
        value: function analyzer(name) {
            return new analyzer_1.ArangoAnalyzer(this._connection, name);
        }
    }, {
        key: "listAnalyzers",
        value: function listAnalyzers() {
            return this._connection.request({ path: "/_api/analyzer" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "analyzers",
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var _this6 = this;

                var analyzers;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.listAnalyzers();

                            case 2:
                                analyzers = _context5.sent;
                                return _context5.abrupt("return", analyzers.map(function (data) {
                                    return _this6.analyzer(data.name);
                                }));

                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function analyzers() {
                return _ref5.apply(this, arguments);
            }

            return analyzers;
        }()
        //#endregion
        //#region transactions

    }, {
        key: "executeTransaction",
        value: function executeTransaction(collections, action, options) {
            return this._connection.request({
                method: "POST",
                path: "/_api/transaction",
                body: _extends({
                    collections: coerceTransactionCollections(collections),
                    action: action
                }, options)
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "transaction",
        value: function transaction(collectionsOrId, action, params, options) {
            if (arguments.length === 1 && typeof collectionsOrId === "string") {
                return new transaction_1.ArangoTransaction(this._connection, collectionsOrId);
            }
            if (typeof params === "number") {
                options = params;
                params = undefined;
            }
            if (typeof options === "number") {
                options = { lockTimeout: options };
            }
            return this.executeTransaction(collectionsOrId, action, _extends({
                params: params
            }, options));
        }
    }, {
        key: "beginTransaction",
        value: function beginTransaction(collections, options) {
            var _this7 = this;

            return this._connection.request({
                method: "POST",
                path: "/_api/transaction/begin",
                body: _extends({
                    collections: coerceTransactionCollections(collections)
                }, options)
            }, function (res) {
                return new transaction_1.ArangoTransaction(_this7._connection, res.body.result.id);
            });
        }
    }, {
        key: "listTransactions",
        value: function listTransactions() {
            return this._connection.request({ path: "/_api/transaction" }, function (res) {
                return res.body.transactions;
            });
        }
    }, {
        key: "transactions",
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var _this8 = this;

                var transactions;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.listTransactions();

                            case 2:
                                transactions = _context6.sent;
                                return _context6.abrupt("return", transactions.map(function (data) {
                                    return _this8.transaction(data.id);
                                }));

                            case 4:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function transactions() {
                return _ref6.apply(this, arguments);
            }

            return transactions;
        }()
        //#endregion
        //#region graphs

    }, {
        key: "graph",
        value: function graph(graphName) {
            return new graph_1.Graph(this._connection, graphName);
        }
    }, {
        key: "listGraphs",
        value: function listGraphs() {
            return this._connection.request({ path: "/_api/gharial" }, function (res) {
                return res.body.graphs;
            });
        }
    }, {
        key: "graphs",
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var _this9 = this;

                var graphs;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.listGraphs();

                            case 2:
                                graphs = _context7.sent;
                                return _context7.abrupt("return", graphs.map(function (data) {
                                    return _this9.graph(data._key);
                                }));

                            case 4:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function graphs() {
                return _ref7.apply(this, arguments);
            }

            return graphs;
        }()
    }, {
        key: "query",
        value: function query(_query, bindVars, opts) {
            var _this10 = this;

            if (aql_query_1.isAqlQuery(_query)) {
                opts = bindVars;
                bindVars = _query.bindVars;
                _query = _query.query;
            } else if (aql_query_1.isAqlLiteral(_query)) {
                _query = _query.toAQL();
            }

            var _ref8 = opts || {},
                _ref8$allowDirtyRead = _ref8.allowDirtyRead,
                allowDirtyRead = _ref8$allowDirtyRead === undefined ? undefined : _ref8$allowDirtyRead,
                _ref8$timeout = _ref8.timeout,
                timeout = _ref8$timeout === undefined ? undefined : _ref8$timeout,
                extra = _objectWithoutProperties(_ref8, ["allowDirtyRead", "timeout"]);

            return this._connection.request({
                method: "POST",
                path: "/_api/cursor",
                body: _extends({}, extra, { query: _query, bindVars: bindVars }),
                allowDirtyRead: allowDirtyRead,
                timeout: timeout
            }, function (res) {
                return new cursor_1.ArrayCursor(_this10._connection, res.body, res.arangojsHostId, allowDirtyRead);
            });
        }
    }, {
        key: "explain",
        value: function explain(query, bindVars, opts) {
            if (aql_query_1.isAqlQuery(query)) {
                opts = bindVars;
                bindVars = query.bindVars;
                query = query.query;
            } else if (aql_query_1.isAqlLiteral(query)) {
                query = query.toAQL();
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/explain",
                body: { options: opts, query: query, bindVars: bindVars }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "parse",
        value: function parse(query) {
            if (aql_query_1.isAqlQuery(query)) {
                query = query.query;
            } else if (aql_query_1.isAqlLiteral(query)) {
                query = query.toAQL();
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/query",
                body: { query: query }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "queryTracking",
        value: function queryTracking() {
            return this._connection.request({
                method: "GET",
                path: "/_api/query/properties"
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "setQueryTracking",
        value: function setQueryTracking(opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/query/properties",
                body: opts
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "listRunningQueries",
        value: function listRunningQueries() {
            return this._connection.request({
                method: "GET",
                path: "/_api/query/current"
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "listSlowQueries",
        value: function listSlowQueries() {
            return this._connection.request({
                method: "GET",
                path: "/_api/query/slow"
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "clearSlowQueries",
        value: function clearSlowQueries() {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/query/slow"
            }, function () {
                return undefined;
            });
        }
    }, {
        key: "killQuery",
        value: function killQuery(queryId) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/query/" + queryId
            }, function () {
                return undefined;
            });
        }
        //#endregion
        //#region functions

    }, {
        key: "listFunctions",
        value: function listFunctions() {
            return this._connection.request({ path: "/_api/aqlfunction" }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createFunction",
        value: function createFunction(name, code) {
            return this._connection.request({
                method: "POST",
                path: "/_api/aqlfunction",
                body: { name: name, code: code }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "dropFunction",
        value: function dropFunction(name) {
            var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this._connection.request({
                method: "DELETE",
                path: "/_api/aqlfunction/" + name,
                body: { group: group }
            }, function (res) {
                return res.body;
            });
        }
        //#endregion
        //#region services

    }, {
        key: "listServices",
        value: function listServices() {
            return this._connection.request({ path: "/_api/foxx" }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "installService",
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(mount, source) {
                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var configuration, dependencies, qs, req;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                configuration = opts.configuration, dependencies = opts.dependencies, qs = _objectWithoutProperties(opts, ["configuration", "dependencies"]);
                                _context8.next = 3;
                                return multipart_1.toForm({
                                    configuration: configuration,
                                    dependencies: dependencies,
                                    source: source
                                });

                            case 3:
                                req = _context8.sent;
                                _context8.next = 6;
                                return this._connection.request(_extends({}, req, {
                                    method: "POST",
                                    path: "/_api/foxx",
                                    isBinary: true,
                                    qs: _extends({}, qs, { mount: mount })
                                }), function (res) {
                                    return res.body;
                                });

                            case 6:
                                return _context8.abrupt("return", _context8.sent);

                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function installService(_x10, _x11) {
                return _ref9.apply(this, arguments);
            }

            return installService;
        }()
    }, {
        key: "upgradeService",
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(mount, source) {
                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var configuration, dependencies, qs, req;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                configuration = opts.configuration, dependencies = opts.dependencies, qs = _objectWithoutProperties(opts, ["configuration", "dependencies"]);
                                _context9.next = 3;
                                return multipart_1.toForm({
                                    configuration: configuration,
                                    dependencies: dependencies,
                                    source: source
                                });

                            case 3:
                                req = _context9.sent;
                                _context9.next = 6;
                                return this._connection.request(_extends({}, req, {
                                    method: "PATCH",
                                    path: "/_api/foxx/service",
                                    isBinary: true,
                                    qs: _extends({}, qs, { mount: mount })
                                }), function (res) {
                                    return res.body;
                                });

                            case 6:
                                return _context9.abrupt("return", _context9.sent);

                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function upgradeService(_x13, _x14) {
                return _ref10.apply(this, arguments);
            }

            return upgradeService;
        }()
    }, {
        key: "replaceService",
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(mount, source) {
                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var configuration, dependencies, qs, req;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                configuration = opts.configuration, dependencies = opts.dependencies, qs = _objectWithoutProperties(opts, ["configuration", "dependencies"]);
                                _context10.next = 3;
                                return multipart_1.toForm({
                                    configuration: configuration,
                                    dependencies: dependencies,
                                    source: source
                                });

                            case 3:
                                req = _context10.sent;
                                _context10.next = 6;
                                return this._connection.request(_extends({}, req, {
                                    method: "PUT",
                                    path: "/_api/foxx/service",
                                    isBinary: true,
                                    qs: _extends({}, qs, { mount: mount })
                                }), function (res) {
                                    return res.body;
                                });

                            case 6:
                                return _context10.abrupt("return", _context10.sent);

                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function replaceService(_x16, _x17) {
                return _ref11.apply(this, arguments);
            }

            return replaceService;
        }()
    }, {
        key: "uninstallService",
        value: function uninstallService(mount) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this._connection.request({
                method: "DELETE",
                path: "/_api/foxx/service",
                qs: _extends({}, opts, { mount: mount })
            }, function () {
                return undefined;
            });
        }
    }, {
        key: "getService",
        value: function getService(mount) {
            return this._connection.request({
                path: "/_api/foxx/service",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getServiceConfiguration",
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(mount) {
                var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                var result, values, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this._connection.request({
                                    path: "/_api/foxx/configuration",
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context11.sent;

                                if (!(!minimal || !Object.keys(result).every(function (key) {
                                    return result[key].title;
                                }))) {
                                    _context11.next = 5;
                                    break;
                                }

                                return _context11.abrupt("return", result);

                            case 5:
                                values = {};
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context11.prev = 9;

                                for (_iterator = Object.keys(result)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    key = _step.value;

                                    values[key] = result[key].current;
                                }
                                _context11.next = 17;
                                break;

                            case 13:
                                _context11.prev = 13;
                                _context11.t0 = _context11["catch"](9);
                                _didIteratorError = true;
                                _iteratorError = _context11.t0;

                            case 17:
                                _context11.prev = 17;
                                _context11.prev = 18;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 20:
                                _context11.prev = 20;

                                if (!_didIteratorError) {
                                    _context11.next = 23;
                                    break;
                                }

                                throw _iteratorError;

                            case 23:
                                return _context11.finish(20);

                            case 24:
                                return _context11.finish(17);

                            case 25:
                                return _context11.abrupt("return", values);

                            case 26:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, this, [[9, 13, 17, 25], [18,, 20, 24]]);
            }));

            function getServiceConfiguration(_x20) {
                return _ref12.apply(this, arguments);
            }

            return getServiceConfiguration;
        }()
    }, {
        key: "updateServiceConfiguration",
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key;

                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this._connection.request({
                                    method: "PATCH",
                                    path: "/_api/foxx/configuration",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context12.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context12.next = 5;
                                    break;
                                }

                                return _context12.abrupt("return", result);

                            case 5:
                                _context12.next = 7;
                                return this.getServiceConfiguration(mount, minimal);

                            case 7:
                                result2 = _context12.sent;

                                if (!result.warnings) {
                                    _context12.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context12.prev = 12;

                                for (_iterator2 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    key = _step2.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context12.next = 20;
                                break;

                            case 16:
                                _context12.prev = 16;
                                _context12.t0 = _context12["catch"](12);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context12.t0;

                            case 20:
                                _context12.prev = 20;
                                _context12.prev = 21;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 23:
                                _context12.prev = 23;

                                if (!_didIteratorError2) {
                                    _context12.next = 26;
                                    break;
                                }

                                throw _iteratorError2;

                            case 26:
                                return _context12.finish(23);

                            case 27:
                                return _context12.finish(20);

                            case 28:
                                return _context12.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function updateServiceConfiguration(_x22, _x23) {
                return _ref13.apply(this, arguments);
            }

            return updateServiceConfiguration;
        }()
    }, {
        key: "replaceServiceConfiguration",
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key;

                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/foxx/configuration",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context13.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context13.next = 5;
                                    break;
                                }

                                return _context13.abrupt("return", result);

                            case 5:
                                _context13.next = 7;
                                return this.getServiceConfiguration(mount, minimal);

                            case 7:
                                result2 = _context13.sent;

                                if (!result.warnings) {
                                    _context13.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion3 = true;
                                _didIteratorError3 = false;
                                _iteratorError3 = undefined;
                                _context13.prev = 12;

                                for (_iterator3 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    key = _step3.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context13.next = 20;
                                break;

                            case 16:
                                _context13.prev = 16;
                                _context13.t0 = _context13["catch"](12);
                                _didIteratorError3 = true;
                                _iteratorError3 = _context13.t0;

                            case 20:
                                _context13.prev = 20;
                                _context13.prev = 21;

                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }

                            case 23:
                                _context13.prev = 23;

                                if (!_didIteratorError3) {
                                    _context13.next = 26;
                                    break;
                                }

                                throw _iteratorError3;

                            case 26:
                                return _context13.finish(23);

                            case 27:
                                return _context13.finish(20);

                            case 28:
                                return _context13.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function replaceServiceConfiguration(_x25, _x26) {
                return _ref14.apply(this, arguments);
            }

            return replaceServiceConfiguration;
        }()
    }, {
        key: "getServiceDependencies",
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(mount) {
                var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                var result, values, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, key;

                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this._connection.request({
                                    path: "/_api/foxx/dependencies",
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context14.sent;

                                if (!(!minimal || !Object.keys(result).every(function (key) {
                                    return result[key].title;
                                }))) {
                                    _context14.next = 5;
                                    break;
                                }

                                return _context14.abrupt("return", result);

                            case 5:
                                values = {};
                                _iteratorNormalCompletion4 = true;
                                _didIteratorError4 = false;
                                _iteratorError4 = undefined;
                                _context14.prev = 9;

                                for (_iterator4 = Object.keys(result)[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    key = _step4.value;

                                    values[key] = result[key].current;
                                }
                                _context14.next = 17;
                                break;

                            case 13:
                                _context14.prev = 13;
                                _context14.t0 = _context14["catch"](9);
                                _didIteratorError4 = true;
                                _iteratorError4 = _context14.t0;

                            case 17:
                                _context14.prev = 17;
                                _context14.prev = 18;

                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }

                            case 20:
                                _context14.prev = 20;

                                if (!_didIteratorError4) {
                                    _context14.next = 23;
                                    break;
                                }

                                throw _iteratorError4;

                            case 23:
                                return _context14.finish(20);

                            case 24:
                                return _context14.finish(17);

                            case 25:
                                return _context14.abrupt("return", values);

                            case 26:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, this, [[9, 13, 17, 25], [18,, 20, 24]]);
            }));

            function getServiceDependencies(_x28) {
                return _ref15.apply(this, arguments);
            }

            return getServiceDependencies;
        }()
    }, {
        key: "updateServiceDependencies",
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, key;

                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this._connection.request({
                                    method: "PATCH",
                                    path: "/_api/foxx/dependencies",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context15.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context15.next = 5;
                                    break;
                                }

                                return _context15.abrupt("return", result);

                            case 5:
                                _context15.next = 7;
                                return this.getServiceDependencies(mount, minimal);

                            case 7:
                                result2 = _context15.sent;

                                if (!result.warnings) {
                                    _context15.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion5 = true;
                                _didIteratorError5 = false;
                                _iteratorError5 = undefined;
                                _context15.prev = 12;

                                for (_iterator5 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    key = _step5.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context15.next = 20;
                                break;

                            case 16:
                                _context15.prev = 16;
                                _context15.t0 = _context15["catch"](12);
                                _didIteratorError5 = true;
                                _iteratorError5 = _context15.t0;

                            case 20:
                                _context15.prev = 20;
                                _context15.prev = 21;

                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }

                            case 23:
                                _context15.prev = 23;

                                if (!_didIteratorError5) {
                                    _context15.next = 26;
                                    break;
                                }

                                throw _iteratorError5;

                            case 26:
                                return _context15.finish(23);

                            case 27:
                                return _context15.finish(20);

                            case 28:
                                return _context15.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function updateServiceDependencies(_x30, _x31) {
                return _ref16.apply(this, arguments);
            }

            return updateServiceDependencies;
        }()
    }, {
        key: "replaceServiceDependencies",
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, key;

                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/foxx/dependencies",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context16.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context16.next = 5;
                                    break;
                                }

                                return _context16.abrupt("return", result);

                            case 5:
                                _context16.next = 7;
                                return this.getServiceDependencies(mount, minimal);

                            case 7:
                                result2 = _context16.sent;

                                if (!result.warnings) {
                                    _context16.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion6 = true;
                                _didIteratorError6 = false;
                                _iteratorError6 = undefined;
                                _context16.prev = 12;

                                for (_iterator6 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    key = _step6.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context16.next = 20;
                                break;

                            case 16:
                                _context16.prev = 16;
                                _context16.t0 = _context16["catch"](12);
                                _didIteratorError6 = true;
                                _iteratorError6 = _context16.t0;

                            case 20:
                                _context16.prev = 20;
                                _context16.prev = 21;

                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }

                            case 23:
                                _context16.prev = 23;

                                if (!_didIteratorError6) {
                                    _context16.next = 26;
                                    break;
                                }

                                throw _iteratorError6;

                            case 26:
                                return _context16.finish(23);

                            case 27:
                                return _context16.finish(20);

                            case 28:
                                return _context16.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context16.stop();
                        }
                    }
                }, _callee16, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function replaceServiceDependencies(_x33, _x34) {
                return _ref17.apply(this, arguments);
            }

            return replaceServiceDependencies;
        }()
    }, {
        key: "enableServiceDevelopmentMode",
        value: function enableServiceDevelopmentMode(mount) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/development",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "disableServiceDevelopmentMode",
        value: function disableServiceDevelopmentMode(mount) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/foxx/development",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "listServiceScripts",
        value: function listServiceScripts(mount) {
            return this._connection.request({
                path: "/_api/foxx/scripts",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "runServiceScript",
        value: function runServiceScript(mount, name, args) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/scripts/" + name,
                body: args,
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "runServiceTests",
        value: function runServiceTests(mount, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/tests",
                qs: _extends({}, opts, {
                    mount: mount
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getServiceReadme",
        value: function getServiceReadme(mount) {
            return this._connection.request({
                path: "/_api/foxx/readme",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getServiceDocumentation",
        value: function getServiceDocumentation(mount) {
            return this._connection.request({
                path: "/_api/foxx/swagger",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "downloadService",
        value: function downloadService(mount) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/download",
                qs: { mount: mount },
                expectBinary: true
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "commitLocalServiceState",
        value: function commitLocalServiceState() {
            var replace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/commit",
                qs: { replace: replace }
            }, function () {
                return undefined;
            });
        }
    }, {
        key: "name",
        get: function get() {
            return this._connection.getDatabaseName() || null;
        }
    }]);

    return Database;
}();

exports.Database = Database;
function coerceTransactionCollections(collections) {
    if (typeof collections === "string") {
        return { write: [collections] };
    }
    if (Array.isArray(collections)) {
        return { write: collections.map(colToString) };
    }
    if (collection_1.isArangoCollection(collections)) {
        return { write: colToString(collections) };
    }
    var cols = {};
    if (collections) {
        if (collections.read) {
            cols.read = Array.isArray(collections.read) ? collections.read.map(colToString) : colToString(collections.read);
        }
        if (collections.write) {
            cols.write = Array.isArray(collections.write) ? collections.write.map(colToString) : colToString(collections.write);
        }
        if (collections.exclusive) {
            cols.exclusive = Array.isArray(collections.exclusive) ? collections.exclusive.map(colToString) : colToString(collections.exclusive);
        }
    }
    return cols;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __webpack_require__(0);
var ANALYZER_NOT_FOUND = 1202;

var ArangoAnalyzer = function () {
    function ArangoAnalyzer(connection, name) {
        _classCallCheck(this, ArangoAnalyzer);

        this.isArangoAnalyzer = true;
        this._connection = connection;
        this.name = name;
    }

    _createClass(ArangoAnalyzer, [{
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/analyzer/" + this.name }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === ANALYZER_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "create",
        value: function create(options) {
            return this._connection.request({
                method: "POST",
                path: "/_api/analyzer",
                body: _extends({ name: this.name }, options)
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "drop",
        value: function drop(force) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/analyzer/" + this.name,
                qs: { force: force }
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return ArangoAnalyzer;
}();

exports.ArangoAnalyzer = ArangoAnalyzer;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __webpack_require__(7);
var error_1 = __webpack_require__(0);
var request_1 = __webpack_require__(29);
var sanitizeUrl_1 = __webpack_require__(56);
var x3_linkedlist_1 = __webpack_require__(57);
var MIME_JSON = /\/(json|javascript)(\W|$)/;
var LEADER_ENDPOINT_HEADER = "x-arango-endpoint";
function isSystemError(err) {
    return Object.getPrototypeOf(err) === Error.prototype && err.hasOwnProperty("code") && err.hasOwnProperty("errno") && err.hasOwnProperty("syscall");
}
function clean(obj) {
    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var value = obj[key];
            if (value === undefined) continue;
            result[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
}

var Connection = function () {
    function Connection() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Connection);

        this._activeTasks = 0;
        this._arangoVersion = 30000;
        this._databaseName = "_system";
        this._queue = new x3_linkedlist_1.LinkedList();
        this._hosts = [];
        this._urls = [];
        this._transactionId = null;
        if (typeof config === "string") config = { url: config };else if (Array.isArray(config)) config = { url: config };
        if (config.arangoVersion !== undefined) {
            this._arangoVersion = config.arangoVersion;
        }
        if (config.isAbsolute) {
            this._databaseName = false;
        }
        this._agent = config.agent;
        this._agentOptions = request_1.isBrowser ? _extends({}, config.agentOptions) : _extends({
            maxSockets: 3,
            keepAlive: true,
            keepAliveMsecs: 1000
        }, config.agentOptions);
        this._maxTasks = this._agentOptions.maxSockets || 3;
        if (this._agentOptions.keepAlive) this._maxTasks *= 2;
        this._headers = _extends({}, config.headers);
        this._loadBalancingStrategy = config.loadBalancingStrategy || "NONE";
        this._useFailOver = this._loadBalancingStrategy !== "ROUND_ROBIN";
        if (config.maxRetries === false) {
            this._shouldRetry = false;
            this._maxRetries = 0;
        } else {
            this._shouldRetry = true;
            this._maxRetries = config.maxRetries || 0;
        }
        var urls = config.url ? Array.isArray(config.url) ? config.url : [config.url] : ["http://localhost:8529"];
        this.addToHostList(urls);
        if (this._loadBalancingStrategy === "ONE_RANDOM") {
            this._activeHost = Math.floor(Math.random() * this._hosts.length);
            this._activeDirtyHost = Math.floor(Math.random() * this._hosts.length);
        } else {
            this._activeHost = 0;
            this._activeDirtyHost = 0;
        }
    }

    _createClass(Connection, [{
        key: "_runQueue",
        value: function _runQueue() {
            var _this = this;

            if (!this._queue.length || this._activeTasks >= this._maxTasks) return;
            var task = this._queue.shift();
            var host = this._activeHost;
            if (task.host !== undefined) {
                host = task.host;
            } else if (task.allowDirtyRead) {
                host = this._activeDirtyHost;
                this._activeDirtyHost = (this._activeDirtyHost + 1) % this._hosts.length;
                task.options.headers["x-arango-allow-dirty-read"] = "true";
            } else if (this._loadBalancingStrategy === "ROUND_ROBIN") {
                this._activeHost = (this._activeHost + 1) % this._hosts.length;
            }
            this._activeTasks += 1;
            var callback = function callback(err, res) {
                _this._activeTasks -= 1;
                if (err) {
                    if (!task.allowDirtyRead && _this._hosts.length > 1 && _this._activeHost === host && _this._useFailOver) {
                        _this._activeHost = (_this._activeHost + 1) % _this._hosts.length;
                    }
                    if (!task.host && _this._shouldRetry && task.retries < (_this._maxRetries || _this._hosts.length - 1) && isSystemError(err) && err.syscall === "connect" && err.code === "ECONNREFUSED") {
                        task.retries += 1;
                        _this._queue.push(task);
                    } else {
                        task.reject(err);
                    }
                } else {
                    var response = res;
                    if (response.statusCode === 503 && response.headers[LEADER_ENDPOINT_HEADER]) {
                        var url = response.headers[LEADER_ENDPOINT_HEADER];

                        var _addToHostList = _this.addToHostList(url),
                            _addToHostList2 = _slicedToArray(_addToHostList, 1),
                            index = _addToHostList2[0];

                        task.host = index;
                        if (_this._activeHost === host) {
                            _this._activeHost = index;
                        }
                        _this._queue.push(task);
                    } else {
                        response.arangojsHostId = host;
                        task.resolve(response);
                    }
                }
                _this._runQueue();
            };
            try {
                this._hosts[host](task.options, callback);
            } catch (e) {
                callback(e);
            }
        }
    }, {
        key: "_buildUrl",
        value: function _buildUrl(_ref) {
            var _ref$absolutePath = _ref.absolutePath,
                absolutePath = _ref$absolutePath === undefined ? false : _ref$absolutePath,
                basePath = _ref.basePath,
                path = _ref.path,
                qs = _ref.qs;

            var pathname = "";
            var search = void 0;
            if (!absolutePath) {
                pathname = this._databasePath;
                if (basePath) pathname += basePath;
            }
            if (path) pathname += path;
            if (qs) {
                if (typeof qs === "string") search = "?" + qs;else search = "?" + querystring_1.stringify(clean(qs));
            }
            return search ? { pathname: pathname, search: search } : { pathname: pathname };
        }
    }, {
        key: "addToHostList",
        value: function addToHostList(urls) {
            var _this2 = this,
                _urls,
                _hosts;

            var cleanUrls = (Array.isArray(urls) ? urls : [urls]).map(function (url) {
                return sanitizeUrl_1.sanitizeUrl(url);
            });
            var newUrls = cleanUrls.filter(function (url) {
                return _this2._urls.indexOf(url) === -1;
            });
            (_urls = this._urls).push.apply(_urls, _toConsumableArray(newUrls));
            (_hosts = this._hosts).push.apply(_hosts, _toConsumableArray(newUrls.map(function (url) {
                return request_1.createRequest(url, _this2._agentOptions, _this2._agent);
            })));
            return cleanUrls.map(function (url) {
                return _this2._urls.indexOf(url);
            });
        }
    }, {
        key: "getDatabaseName",
        value: function getDatabaseName() {
            return this._databaseName;
        }
    }, {
        key: "getActiveHost",
        value: function getActiveHost() {
            return this._activeHost;
        }
    }, {
        key: "setDatabaseName",
        value: function setDatabaseName(databaseName) {
            if (this._databaseName === false) {
                throw new Error("Can not change database from absolute URL");
            }
            this._databaseName = databaseName;
        }
    }, {
        key: "setTransactionId",
        value: function setTransactionId(transactionId) {
            this._transactionId = transactionId;
        }
    }, {
        key: "clearTransactionId",
        value: function clearTransactionId() {
            this._transactionId = null;
        }
    }, {
        key: "setHeader",
        value: function setHeader(key, value) {
            this._headers[key] = value;
        }
    }, {
        key: "close",
        value: function close() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this._hosts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var host = _step2.value;

                    if (host.close) host.close();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: "request",
        value: function request(_ref2, getter) {
            var _this3 = this;

            var host = _ref2.host,
                _ref2$method = _ref2.method,
                method = _ref2$method === undefined ? "GET" : _ref2$method,
                body = _ref2.body,
                _ref2$expectBinary = _ref2.expectBinary,
                expectBinary = _ref2$expectBinary === undefined ? false : _ref2$expectBinary,
                _ref2$isBinary = _ref2.isBinary,
                isBinary = _ref2$isBinary === undefined ? false : _ref2$isBinary,
                _ref2$allowDirtyRead = _ref2.allowDirtyRead,
                allowDirtyRead = _ref2$allowDirtyRead === undefined ? false : _ref2$allowDirtyRead,
                _ref2$timeout = _ref2.timeout,
                timeout = _ref2$timeout === undefined ? 0 : _ref2$timeout,
                headers = _ref2.headers,
                urlInfo = _objectWithoutProperties(_ref2, ["host", "method", "body", "expectBinary", "isBinary", "allowDirtyRead", "timeout", "headers"]);

            return new Promise(function (_resolve, reject) {
                var contentType = "text/plain";
                if (isBinary) {
                    contentType = "application/octet-stream";
                } else if (body) {
                    if ((typeof body === "undefined" ? "undefined" : _typeof(body)) === "object") {
                        body = JSON.stringify(body);
                        contentType = "application/json";
                    } else {
                        body = String(body);
                    }
                }
                var extraHeaders = _extends({}, _this3._headers, {
                    "content-type": contentType,
                    "x-arango-version": String(_this3._arangoVersion)
                });
                if (_this3._transactionId) {
                    extraHeaders["x-arango-trx-id"] = _this3._transactionId;
                }
                _this3._queue.push({
                    retries: 0,
                    host: host,
                    allowDirtyRead: allowDirtyRead,
                    options: {
                        url: _this3._buildUrl(urlInfo),
                        headers: _extends({}, extraHeaders, headers),
                        timeout: timeout,
                        method: method,
                        expectBinary: expectBinary,
                        body: body
                    },
                    reject: reject,
                    resolve: function resolve(res) {
                        var contentType = res.headers["content-type"];
                        var parsedBody = undefined;
                        if (res.body.length && contentType && contentType.match(MIME_JSON)) {
                            try {
                                parsedBody = res.body;
                                parsedBody = JSON.parse(parsedBody);
                            } catch (e) {
                                if (!expectBinary) {
                                    if (typeof parsedBody !== "string") {
                                        parsedBody = res.body.toString("utf-8");
                                    }
                                    e.response = res;
                                    reject(e);
                                    return;
                                }
                            }
                        } else if (res.body && !expectBinary) {
                            parsedBody = res.body.toString("utf-8");
                        } else {
                            parsedBody = res.body;
                        }
                        if (parsedBody && parsedBody.hasOwnProperty("error") && parsedBody.hasOwnProperty("code") && parsedBody.hasOwnProperty("errorMessage") && parsedBody.hasOwnProperty("errorNum")) {
                            res.body = parsedBody;
                            reject(new error_1.ArangoError(res));
                        } else if (res.statusCode && res.statusCode >= 400) {
                            res.body = parsedBody;
                            reject(new error_1.HttpError(res));
                        } else {
                            if (!expectBinary) res.body = parsedBody;
                            _resolve(getter ? getter(res) : res);
                        }
                    }
                });
                _this3._runQueue();
            });
        }
    }, {
        key: "_databasePath",
        get: function get() {
            return this._databaseName === false ? "" : "/_db/" + this._databaseName;
        }
    }, {
        key: "arangoMajor",
        get: function get() {
            return Math.floor(this._arangoVersion / 10000);
        }
    }]);

    return Connection;
}();

exports.Connection = Connection;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v === 'undefined' ? 'undefined' : _typeof(v)) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __webpack_require__(30);
var joinPath_1 = __webpack_require__(33);
var xhr_1 = __webpack_require__(36);
exports.isBrowser = true;
function omit(obj, keys) {
    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (keys.includes(key)) continue;
            result[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
}
function createRequest(baseUrl, agentOptions) {
    var _url_1$parse = url_1.parse(baseUrl),
        auth = _url_1$parse.auth,
        baseUrlParts = _objectWithoutProperties(_url_1$parse, ["auth"]);

    var options = omit(agentOptions, ["keepAlive", "keepAliveMsecs", "maxSockets"]);
    return function request(_ref, cb) {
        var method = _ref.method,
            url = _ref.url,
            headers = _ref.headers,
            body = _ref.body,
            timeout = _ref.timeout,
            expectBinary = _ref.expectBinary;

        var urlParts = _extends({}, baseUrlParts, {
            pathname: url.pathname ? baseUrlParts.pathname ? joinPath_1.joinPath(baseUrlParts.pathname, url.pathname) : url.pathname : baseUrlParts.pathname,
            search: url.search ? baseUrlParts.search ? baseUrlParts.search + "&" + url.search.slice(1) : url.search : baseUrlParts.search
        });
        if (!headers["authorization"]) {
            headers["authorization"] = "Basic " + btoa(auth || "root:");
        }
        var _callback = function callback(err, res) {
            _callback = function callback() {
                return undefined;
            };
            cb(err, res);
        };
        var req = xhr_1.default(_extends({
            responseType: expectBinary ? "blob" : "text"
        }, options, {
            url: url_1.format(urlParts),
            withCredentials: true,
            useXDR: true,
            body: body,
            method: method,
            headers: headers,
            timeout: timeout
        }), function (err, res) {
            if (!err) {
                if (!res.body) res.body = "";
                _callback(null, res);
            } else {
                var error = err;
                error.request = req;
                _callback(error);
            }
        });
    };
}
exports.createRequest = createRequest;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var punycode = __webpack_require__(31);
var util = __webpack_require__(32);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,


// Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,


// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


// RFC 2396: characters not allowed for various reasons.
unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = ['\''].concat(unwise),

// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

// protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that never have a hostname.
hostlessProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that always contain a // bit.
slashedProtocol = {
  'http': true,
  'https': true,
  'ftp': true,
  'gopher': true,
  'file': true,
  'http:': true,
  'https:': true,
  'ftp:': true,
  'gopher:': true,
  'file:': true
},
    querystring = __webpack_require__(7);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === 'undefined' ? 'undefined' : _typeof(url)));
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || query && '?' + query || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {}
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
      isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
      mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || result.host && srcPath.length;

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.4.1',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if ("function" == 'function' && _typeof(__webpack_require__(9)) == 'object' && __webpack_require__(9)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), __webpack_require__(8)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isObject: function isObject(arg) {
    return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var path_1 = __webpack_require__(34);
exports.joinPath = path_1.join;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function () {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = i >= 0 ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function (path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function (path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function () {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function (p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};

// path.relative(from, to)
// posix version
exports.relative = function (from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
      } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
  // We saw a non-dot character immediately before the dot
  preDotState === 0 ||
  // The (right-most) trimmed path component is exactly '..'
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter(xs, f) {
  if (xs.filter) return xs.filter(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) res.push(xs[i]);
  }
  return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
  return str.substr(start, len);
} : function (str, start, len) {
  if (start < 0) start = str.length + start;
  return str.substr(start, len);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.default = __webpack_require__(37);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var window = __webpack_require__(38);
var isFunction = __webpack_require__(39);
var parseHeaders = __webpack_require__(40);
var xtend = __webpack_require__(55);

module.exports = createXHR;
// Allow use of default import syntax in TypeScript
module.exports.default = createXHR;
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;

forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
    createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
        options = initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return _createXHR(options);
    };
});

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i]);
    }
}

function isEmpty(obj) {
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}

function initParams(uri, options, callback) {
    var params = uri;

    if (isFunction(options)) {
        callback = options;
        if (typeof uri === "string") {
            params = { uri: uri };
        }
    } else {
        params = xtend(options, { uri: uri });
    }

    params.callback = callback;
    return params;
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback);
    return _createXHR(options);
}

function _createXHR(options) {
    if (typeof options.callback === "undefined") {
        throw new Error("callback argument missing");
    }

    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };

    function readystatechange() {
        if (xhr.readyState === 4) {
            setTimeout(loadFunc, 0);
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;

        if (xhr.response) {
            body = xhr.response;
        } else {
            body = xhr.responseText || getXml(xhr);
        }

        if (isJson) {
            try {
                body = JSON.parse(body);
            } catch (e) {}
        }

        return body;
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) {
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        }
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200;
        } else {
            status = xhr.status === 1223 ? 204 : xhr.status;
        }
        var response = failureResponse;
        var err = null;

        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) {
                //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders());
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error");
        }
        return callback(err, response, response.body);
    }

    var xhr = options.xhr || null;

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest();
        } else {
            xhr = new createXHR.XMLHttpRequest();
        }
    }

    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };

    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }

    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc;
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    };
    xhr.onabort = function () {
        aborted = true;
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password);
    //has to be after open
    if (!sync) {
        xhr.withCredentials = !!options.withCredentials;
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) {
        timeoutTimer = setTimeout(function () {
            if (aborted) return;
            aborted = true; //IE9 may still call readystatechange
            xhr.abort("timeout");
            var e = new Error("XMLHttpRequest timeout");
            e.code = "ETIMEDOUT";
            errorFunc(e);
        }, options.timeout);
    }

    if (xhr.setRequestHeader) {
        for (key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object");
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType;
    }

    if ("beforeSend" in options && typeof options.beforeSend === "function") {
        options.beforeSend(xhr);
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);

    return xhr;
}

function getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") {
            return xhr.responseXML;
        }
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) {
            return xhr.responseXML;
        }
    } catch (e) {}

    return null;
}

function noop() {}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined") {
    win = self;
} else {
    win = {};
}

module.exports = win;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = isFunction;

var toString = Object.prototype.toString;

function isFunction(fn) {
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (
  // IE8 and below
  fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(41),
    forEach = __webpack_require__(54),
    isArray = function isArray(arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

module.exports = function (headers) {
  if (!headers) return {};

  var result = {};

  forEach(trim(headers).split('\n'), function (row) {
    var index = row.indexOf(':'),
        key = trim(row.slice(0, index)).toLowerCase(),
        value = trim(row.slice(index + 1));

    if (typeof result[key] === 'undefined') {
      result[key] = value;
    } else if (isArray(result[key])) {
      result[key].push(value);
    } else {
      result[key] = [result[key], value];
    }
  });

  return result;
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(2);
var define = __webpack_require__(10);

var implementation = __webpack_require__(12);
var getPolyfill = __webpack_require__(15);
var shim = __webpack_require__(53);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(11);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
	return origKeys(o);
} : __webpack_require__(44);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2);
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) {
				// eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(11); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
	var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = function () {
		/* global window */
		if (typeof window === 'undefined') {
			return false;
		}
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && _typeof(window[k]) === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}();
	var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GetIntrinsic = __webpack_require__(13);

var $Object = GetIntrinsic('%Object%');
var $TypeError = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%');

var assertRecord = __webpack_require__(46);
var $isNaN = __webpack_require__(47);
var $isFinite = __webpack_require__(48);

var sign = __webpack_require__(49);
var mod = __webpack_require__(50);

var IsCallable = __webpack_require__(3);
var toPrimitive = __webpack_require__(51);

var has = __webpack_require__(14);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) {
			return 0;
		}
		if (number === 0 || !$isFinite(number)) {
			return number;
		}
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) {
			return 0;
		}
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return $String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return $Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new $TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) {
			// 0 === -0, but they are not identical.
			if (x === 0) {
				return 1 / x === 1 / y;
			}
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// https://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) {
			// eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(13);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(14);

var predicates = {
  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
    if (ES.Type(Desc) !== 'Object') {
      return false;
    }
    var allowed = {
      '[[Configurable]]': true,
      '[[Enumerable]]': true,
      '[[Get]]': true,
      '[[Set]]': true,
      '[[Value]]': true,
      '[[Writable]]': true
    };

    for (var key in Desc) {
      // eslint-disable-line
      if (has(Desc, key) && !allowed[key]) {
        return false;
      }
    }

    var isData = has(Desc, '[[Value]]');
    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
    if (isData && IsAccessor) {
      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
    }
    return true;
  }
};

module.exports = function assertRecord(ES, recordType, argumentName, value) {
  var predicate = predicates[recordType];
  if (typeof predicate !== 'function') {
    throw new $SyntaxError('unknown record type: ' + recordType);
  }
  if (!predicate(ES, value)) {
    throw new $TypeError(argumentName + ' must be a ' + recordType);
  }
  console.log(predicate(ES, value), value);
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = Number.isNaN || function (a) {
  return a !== a;
};

module.exports = Number.isFinite || function (x) {
  return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity;
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(52);

var isCallable = __webpack_require__(3);

// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
var ES5internalSlots = {
	'[[DefaultValue]]': function DefaultValue(O) {
		var actualHint;
		if (arguments.length > 1) {
			actualHint = arguments[1];
		} else {
			actualHint = toStr.call(O) === '[object Date]' ? String : Number;
		}

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// http://ecma-international.org/ecma-262/5.1/#sec-9.1
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	if (arguments.length > 1) {
		return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
	}
	return ES5internalSlots['[[DefaultValue]]'](input);
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isPrimitive(value) {
	return value === null || typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object';
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(10);
var getPolyfill = __webpack_require__(15);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, {
		trim: function testTrim() {
			return String.prototype.trim !== polyfill;
		}
	});
	return polyfill;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(3);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = extend;

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function sanitizeUrl(url) {
    var raw = url.match(/^(tcp|ssl|tls)((?::|\+).+)/);
    if (raw) url = (raw[1] === "tcp" ? "http" : "https") + raw[2];
    var unix = url.match(/^(?:(https?)\+)?unix:\/\/(\/.+)/);
    if (unix) url = (unix[1] || "http") + "://unix:" + unix[2];
    return url;
}
exports.sanitizeUrl = sanitizeUrl;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(58));
__export(__webpack_require__(16));
//# sourceMappingURL=index.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedListItem_1 = __webpack_require__(16);
/**
 * Implements a linked list structure
 * @typeparam T Type of values within this LinkedList
 */

var LinkedList = function () {
    /**
     * @param values Values to be added upfront into list
     */
    function LinkedList(values) {
        var _this = this;

        _classCallCheck(this, LinkedList);

        /**
         * Current length of this LinkedList.
         * Note that this does not work anymore if you for some reason add your own LinkedListItems to LinkedList by hand
         */
        this.length = 0;
        /**
         * Given to own LinkedListItem's for following jobs regarding an unlink:
         * - If item is first item, set the next item as first item
         * - If item is last item, set the previous item as last item
         * - Decrease length
         * @param item Item that has been unlinked
         */
        this.unlinkCleanup = function (item) {
            if (_this.first === item) {
                _this.first = _this.first.behind;
            }
            if (_this.last === item) {
                _this.last = _this.last.before;
            }
            _this.length--;
        };
        if (values) {
            if (values instanceof LinkedList) {
                values = values.values();
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var value = _step.value;

                    this.push(value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    /**
     * As Array#every() given callback is called for every element until one call returns falsy or all elements had been processed
     * @returns `false` if there was a falsy response from the callback, `true` if all elements have been processed "falselesly"
     * @see Array#every
     */


    _createClass(LinkedList, [{
        key: "every",
        value: function every(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (!callback(item.value, item, this)) {
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return true;
        }
        /**
         * Filters values into a new LinkedList
         * @param callback decides wether given element should be part of new LinkedList
         * @see Array#filter
         */

    }, {
        key: "filter",
        value: function filter(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var newList = new LinkedList();
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _ref = _step3.value;

                    var _ref2 = _slicedToArray(_ref, 2);

                    var item = _ref2[0];
                    var value = _ref2[1];

                    if (callback(value, item, this)) {
                        newList.push(value);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return newList;
        }
        /**
         * Returns value for which given callback returns truthy
         * @param callback runs for every value in LinkedList. If it returns truthy, current value is returned.
         * @see Array#find
         */

    }, {
        key: "find",
        value: function find(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = this[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _ref3 = _step4.value;

                    var _ref4 = _slicedToArray(_ref3, 2);

                    var item = _ref4[0];
                    var value = _ref4[1];

                    if (callback(value, item, this)) {
                        return value;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
        /**
         * Returns the LinkedListItem for which given callback returns truthy
         * @param callback runs for every LinkedListItem in LinkedList. If it returns truthy, current LinkedListItem is returned.
         * @see Array#findIndex
         */

    }, {
        key: "findItem",
        value: function findItem(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = this[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _ref5 = _step5.value;

                    var _ref6 = _slicedToArray(_ref5, 2);

                    var item = _ref6[0];
                    var value = _ref6[1];

                    if (callback(value, item, this)) {
                        return item;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
        /**
         * Iterates this LinkedList's items and values
         * @param callback Gets every value in LinkedList once with corresponding LinkedListItem and LinkedList
         * @param thisArg If given, callback will be bound here
         * @see Array#forEach
         */

    }, {
        key: "forEach",
        value: function forEach(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = this[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var _ref7 = _step6.value;

                    var _ref8 = _slicedToArray(_ref7, 2);

                    var item = _ref8[0];
                    var value = _ref8[1];

                    callback(value, item, this);
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        }
        /**
         * Checks if value can be found within LinkedList, starting from fromIndex, if given.
         * @param value value to be found in this
         * @param fromIndex Starting index. Supports negative values for which `this.size - 1 + fromIndex` will be used as starting point.
         * @returns true if value could be found in LinkedList (respecting fromIndex), false otherwhise
         * @see Array#includes
         */

    }, {
        key: "includes",
        value: function includes(value) {
            var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var current = this.getItemByIndex(fromIndex);
            while (current) {
                if (current.value === value) {
                    return true;
                }
                current = current.behind;
            }
            return false;
        }
        /**
         * Searches forward for given value and returns the first corresponding LinkedListItem found
         * @param searchedValue Value to be found
         * @param fromIndex Index to start from
         * @see Array#indexOf
         */

    }, {
        key: "itemOf",
        value: function itemOf(searchedValue) {
            var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var current = this.getItemByIndex(fromIndex);
            while (current) {
                if (current.value === searchedValue) {
                    return current;
                }
                current = current.behind;
            }
            return;
        }
        /**
         * Searches backwards for given value and returns the first corresponding LinkedListItem found
         * @param searchedValue Value to be found
         * @param fromIndex Index to start from
         * @see Array#indexOf
         */

    }, {
        key: "lastItemOf",
        value: function lastItemOf(searchedValue) {
            var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

            var current = this.getItemByIndex(fromIndex);
            while (current) {
                if (current.value === searchedValue) {
                    return current;
                }
                current = current.before;
            }
            return;
        }
        /**
         * Creates a new LinkedList with each of its itesm representing the output of the callback with each item in current LinkedList.
         * @param callback Gets value, LinkedListeItem and LinkedList. The response will be used as value in the new LinkedList
         * @param thisArg If given, callback is bound to thisArg
         * @see Array#map
         */

    }, {
        key: "map",
        value: function map(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var newList = new LinkedList();
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = this[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _ref9 = _step7.value;

                    var _ref10 = _slicedToArray(_ref9, 2);

                    var item = _ref10[0];
                    var value = _ref10[1];

                    newList.push(callback(value, item, this));
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            return newList;
        }
    }, {
        key: "reduce",
        value: function reduce(callback, initialValue) {
            var current = this.first;
            if (!current) {
                if (!initialValue) {
                    throw new TypeError("Empty accumulator on empty LinkedList is not allowed.");
                }
                return initialValue;
            }
            if (initialValue === undefined) {
                initialValue = current.value;
                if (!current.behind) {
                    return initialValue;
                }
                current = current.behind;
            } else {
                initialValue = initialValue;
            }
            do {
                initialValue = callback(initialValue, current.value, current, this);
                current = current.behind;
            } while (current);
            return initialValue;
        }
    }, {
        key: "reduceRight",
        value: function reduceRight(callback, initialValue) {
            var current = this.last;
            if (!current) {
                if (!initialValue) {
                    throw new TypeError("Empty accumulator on empty LinkedList is not allowed.");
                }
                return initialValue;
            }
            // let accumulator: V | T;
            if (initialValue === undefined) {
                initialValue = current.value;
                if (!current.before) {
                    return initialValue;
                }
                current = current.before;
            } else {
                initialValue = initialValue;
            }
            do {
                initialValue = callback(initialValue, current.value, current, this);
                current = current.before;
            } while (current);
            return initialValue;
        }
        /**
         * Runs callback for every entry and returns true immediately if call of callback returns truthy.
         * @param callback called for every element. If response is truthy, iteration
         * @param thisArg If set, callback is bound to this
         * @returns `true` once a callback call returns truthy, `false` if none returned truthy.
         */

    }, {
        key: "some",
        value: function some(callback, thisArg) {
            if (thisArg) {
                callback = callback.bind(thisArg);
            }
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = this[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var _ref11 = _step8.value;

                    var _ref12 = _slicedToArray(_ref11, 2);

                    var item = _ref12[0];
                    var value = _ref12[1];

                    if (callback(value, item, this)) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            return false;
        }
        /**
         * Joins values within this by given separator. Uses Array#join directly.
         * @param separator separator to be used
         * @see Array#join
         */

    }, {
        key: "join",
        value: function join(separator) {
            return [].concat(_toConsumableArray(this.values())).join(separator);
        }
        /**
         * Concats given values and returns a new LinkedList with all given values.
         * If LinkedList's are given, they will be spread.
         * @param others Other values or lists to be concat'ed together
         * @see Array#concat
         */

    }, {
        key: "concat",
        value: function concat() {
            var newList = new LinkedList(this);

            for (var _len = arguments.length, others = Array(_len), _key = 0; _key < _len; _key++) {
                others[_key] = arguments[_key];
            }

            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = others[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var other = _step9.value;

                    if (other instanceof LinkedList) {
                        newList.push.apply(newList, _toConsumableArray(other.values()));
                    } else {
                        newList.push(other);
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            return newList;
        }
        /**
         * Removes the last LinkedListItem and returns its inner value
         */

    }, {
        key: "pop",
        value: function pop() {
            if (!this.last) {
                return;
            }
            var item = this.last;
            item.unlink();
            return item.value;
        }
        /**
         * Adds given values on the end of this LinkedList
         * @param values Values to be added
         */

    }, {
        key: "push",
        value: function push() {
            for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                values[_key2] = arguments[_key2];
            }

            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = values[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var value = _step10.value;

                    var item = new LinkedListItem_1.LinkedListItem(value, this.unlinkCleanup);
                    if (!this.first || !this.last) {
                        this.first = this.last = item;
                    } else {
                        this.last.insertBehind(item);
                        this.last = item;
                    }
                    this.length++;
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }
        }
        /**
         * Adds given values to the beginning of this LinkedList
         * @param values Values to be added
         */

    }, {
        key: "unshift",
        value: function unshift() {
            for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                values[_key3] = arguments[_key3];
            }

            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = values[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var value = _step11.value;

                    var item = new LinkedListItem_1.LinkedListItem(value, this.unlinkCleanup);
                    if (!this.last || !this.first) {
                        this.first = this.last = item;
                    } else {
                        item.insertBehind(this.first);
                        this.first = item;
                    }
                    this.length++;
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }
        }
        /**
         * Removes first occurrence of value found.
         * @param value value to remove from LinkedList
         */

    }, {
        key: "remove",
        value: function remove(value) {
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
                for (var _iterator12 = this.keys()[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var item = _step12.value;

                    if (item.value === value) {
                        item.unlink();
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                        _iterator12.return();
                    }
                } finally {
                    if (_didIteratorError12) {
                        throw _iteratorError12;
                    }
                }
            }

            return false;
        }
        /**
         * Removes every occurrance of value within this.
         * @param value value to remove from LinkedList
         */

    }, {
        key: "removeAllOccurrences",
        value: function removeAllOccurrences(value) {
            var foundSomethingToDelete = false;
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
                for (var _iterator13 = this.keys()[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                    var item = _step13.value;

                    if (item.value === value) {
                        item.unlink();
                        foundSomethingToDelete = true;
                    }
                }
            } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion13 && _iterator13.return) {
                        _iterator13.return();
                    }
                } finally {
                    if (_didIteratorError13) {
                        throw _iteratorError13;
                    }
                }
            }

            return foundSomethingToDelete;
        }
        /**
         * Returns and removes first element from LinkedList
         */

    }, {
        key: "shift",
        value: function shift() {
            if (!this.first) {
                return;
            }
            var item = this.first;
            item.unlink();
            return item.value;
        }
        /**
         * Returns LinkedListItem and value for every entry of this LinkedList
         */

    }, {
        key: Symbol.iterator,
        value: /*#__PURE__*/regeneratorRuntime.mark(function value() {
            var current;
            return regeneratorRuntime.wrap(function value$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            current = this.first;

                            if (current) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt("return");

                        case 3:
                            _context.next = 5;
                            return [current, current.value];

                        case 5:
                            current = current.behind;

                        case 6:
                            if (current) {
                                _context.next = 3;
                                break;
                            }

                        case 7:
                        case "end":
                            return _context.stop();
                    }
                }
            }, value, this);
        })
        /**
         * Returns LinkedListItem and value for every entry of this LinkedList
         * @see LinkedList#Symbol.iterator
         */

    }, {
        key: "entries",
        value: function entries() {
            return this[Symbol.iterator]();
        }
        /**
         * Iterates the LinkedListItem's of this LinkedList
         */

    }, {
        key: "keys",
        value: /*#__PURE__*/regeneratorRuntime.mark(function keys() {
            var current;
            return regeneratorRuntime.wrap(function keys$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            current = this.first;

                            if (current) {
                                _context2.next = 3;
                                break;
                            }

                            return _context2.abrupt("return");

                        case 3:
                            _context2.next = 5;
                            return current;

                        case 5:
                            current = current.behind;

                        case 6:
                            if (current) {
                                _context2.next = 3;
                                break;
                            }

                        case 7:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, keys, this);
        })
        /**
         * Returns a value for every entry of this LinkedList
         */

    }, {
        key: "values",
        value: /*#__PURE__*/regeneratorRuntime.mark(function values() {
            var current;
            return regeneratorRuntime.wrap(function values$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            current = this.first;

                            if (current) {
                                _context3.next = 3;
                                break;
                            }

                            return _context3.abrupt("return");

                        case 3:
                            _context3.next = 5;
                            return current.value;

                        case 5:
                            current = current.behind;

                        case 6:
                            if (current) {
                                _context3.next = 3;
                                break;
                            }

                        case 7:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, values, this);
        })
        /**
         * Returns the item by given index.
         * Supports negative values and will return the item at `LinkedList.size - 1 + index` in that case.
         * @param index Index of item to get from list
         */

    }, {
        key: "getItemByIndex",
        value: function getItemByIndex(index) {
            if (index === undefined) {
                throw new Error("index must be a number!");
            }
            if (!this.first) {
                return;
            }
            var current = void 0;
            if (index > 0) {
                current = this.first;
                while (current && index--) {
                    current = current.behind;
                }
            } else if (index < 0) {
                current = this.last;
                while (current && ++index) {
                    current = current.before;
                }
            } else {
                return this.first;
            }
            return current;
        }
    }]);

    return LinkedList;
}();

exports.LinkedList = LinkedList;
//# sourceMappingURL=LinkedList.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Route = function () {
    function Route(connection) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, Route);

        if (!path) path = "";else if (path.charAt(0) !== "/") path = "/" + path;
        this._connection = connection;
        this._path = path;
        this._headers = headers;
    }

    _createClass(Route, [{
        key: "route",
        value: function route(path, headers) {
            if (!path) path = "";else if (path.charAt(0) !== "/") path = "/" + path;
            return new Route(this._connection, this._path + path, _extends({}, this._headers, headers));
        }
    }, {
        key: "request",
        value: function request(_ref) {
            var method = _ref.method,
                path = _ref.path,
                _ref$headers = _ref.headers,
                headers = _ref$headers === undefined ? {} : _ref$headers,
                opts = _objectWithoutProperties(_ref, ["method", "path", "headers"]);

            if (!path) opts.path = "";else if (this._path && path.charAt(0) !== "/") opts.path = "/" + path;else opts.path = path;
            opts.basePath = this._path;
            opts.headers = _extends({}, this._headers, headers);
            opts.method = method ? method.toUpperCase() : "GET";
            return this._connection.request(opts);
        }
    }, {
        key: "_request1",
        value: function _request1(method) {
            var path = "";
            var qs = void 0;
            var headers = void 0;

            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            if (args[0] === undefined || typeof args[0] === "string") {
                path = args.shift();
            }
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                qs = args.shift();
            }
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                headers = args.shift();
            }
            return this.request({ method: method, path: path, qs: qs, headers: headers });
        }
    }, {
        key: "_request2",
        value: function _request2(method) {
            var path = "";
            var body = undefined;
            var qs = void 0;
            var headers = void 0;

            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            if (args[0] === undefined || typeof args[0] === "string") {
                path = args.shift();
            }
            body = args.shift();
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                qs = args.shift();
            }
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                headers = args.shift();
            }
            return this.request({ method: method, path: path, body: body, qs: qs, headers: headers });
        }
    }, {
        key: "delete",
        value: function _delete() {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return this._request1.apply(this, ["DELETE"].concat(args));
        }
    }, {
        key: "get",
        value: function get() {
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            return this._request1.apply(this, ["GET"].concat(args));
        }
    }, {
        key: "head",
        value: function head() {
            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            return this._request1.apply(this, ["HEAD"].concat(args));
        }
    }, {
        key: "patch",
        value: function patch() {
            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                args[_key6] = arguments[_key6];
            }

            return this._request2.apply(this, ["PATCH"].concat(args));
        }
    }, {
        key: "post",
        value: function post() {
            for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                args[_key7] = arguments[_key7];
            }

            return this._request2.apply(this, ["POST"].concat(args));
        }
    }, {
        key: "put",
        value: function put() {
            for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                args[_key8] = arguments[_key8];
            }

            return this._request2.apply(this, ["PUT"].concat(args));
        }
    }]);

    return Route;
}();

exports.Route = Route;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __webpack_require__(0);
var TRANSACTION_NOT_FOUND = 10;

var ArangoTransaction = function () {
    function ArangoTransaction(connection, id) {
        _classCallCheck(this, ArangoTransaction);

        this.isArangoTransaction = true;
        this._connection = connection;
        this.id = id;
    }

    _createClass(ArangoTransaction, [{
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === TRANSACTION_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "get",
        value: function get() {
            return this._connection.request({
                path: "/_api/transaction/" + this.id
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "commit",
        value: function commit() {
            return this._connection.request({
                method: "PUT",
                path: "/_api/transaction/" + this.id
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "abort",
        value: function abort() {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/transaction/" + this.id
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "run",
        value: function run(fn) {
            this._connection.setTransactionId(this.id);
            try {
                return Promise.resolve(fn());
            } finally {
                this._connection.clearTransactionId();
            }
        }
    }]);

    return ArangoTransaction;
}();

exports.ArangoTransaction = ArangoTransaction;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function btoa(str) {
    return window.btoa(str);
}
exports.btoa = btoa;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
function toForm(fields, callback) {
    var form = void 0;
    try {
        form = new FormData();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(fields)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                var value = fields[key];
                if (value === undefined) continue;
                if (!(value instanceof Blob) && ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" || typeof value === "function")) {
                    value = JSON.stringify(value);
                }
                form.append(key, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } catch (e) {
        callback(e);
        return;
    }
    callback(null, { body: form });
}
exports.toForm = toForm;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __webpack_require__(0);
var ViewType;
(function (ViewType) {
    ViewType["ARANGOSEARCH_VIEW"] = "arangosearch";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
var VIEW_NOT_FOUND = 1203;

var BaseView = function () {
    function BaseView(connection, name) {
        _classCallCheck(this, BaseView);

        this.isArangoView = true;
        this.name = name;
        this._connection = connection;
    }

    _createClass(BaseView, [{
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/view/" + this.name }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === VIEW_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "rename",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
                var result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/view/" + this.name + "/rename",
                                    body: { name: name }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context.sent;

                                this.name = name;
                                return _context.abrupt("return", result);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function rename(_x) {
                return _ref.apply(this, arguments);
            }

            return rename;
        }()
    }, {
        key: "drop",
        value: function drop() {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/view/" + this.name
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return BaseView;
}();

exports.BaseView = BaseView;

var ArangoSearchView = function (_BaseView) {
    _inherits(ArangoSearchView, _BaseView);

    function ArangoSearchView() {
        _classCallCheck(this, ArangoSearchView);

        var _this = _possibleConstructorReturn(this, (ArangoSearchView.__proto__ || Object.getPrototypeOf(ArangoSearchView)).apply(this, arguments));

        _this.type = ViewType.ARANGOSEARCH_VIEW;
        return _this;
    }

    _createClass(ArangoSearchView, [{
        key: "create",
        value: function create() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._connection.request({
                method: "POST",
                path: "/_api/view",
                body: _extends({}, properties, {
                    name: this.name,
                    type: this.type
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "properties",
        value: function properties() {
            return this._connection.request({ path: "/_api/view/" + this.name + "/properties" }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "setProperties",
        value: function setProperties() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._connection.request({
                method: "PATCH",
                path: "/_api/view/" + this.name + "/properties",
                body: properties
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "replaceProperties",
        value: function replaceProperties() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._connection.request({
                method: "PUT",
                path: "/_api/view/" + this.name + "/properties",
                body: properties
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return ArangoSearchView;
}(BaseView);

exports.ArangoSearchView = ArangoSearchView;
function constructView(connection, data) {
    if (data.type && data.type !== ViewType.ARANGOSEARCH_VIEW) {
        throw new Error("Unknown view type \"" + data.type + "\"");
    }
    return new ArangoSearchView(connection, data.name);
}
exports.constructView = constructView;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// web.js